export const common = {
  // Navigation
  'nav.features': 'Tính năng',
  'nav.howItWorks': 'Cách hoạt động',
  'nav.pricing': 'Bảng giá',
  'nav.faq': 'Câu hỏi thường gặp',
  'nav.aboutUs': 'Về chúng tôi',
  'nav.getStarted': 'Bắt đầu',

  // About Us Section
  'aboutUs.badge': "Về chúng tôi",
  'aboutUs.title': "Vì sao IdeaVerdict tồn tại",
  'aboutUs.line1': "Ai cũng có thể có ý tưởng.",
  'aboutUs.line2': "Ít ai chịu thừa nhận ý tưởng của mình sẽ không sống nổi.",
  'aboutUs.paragraph1':
    "Phần lớn ý tưởng thất bại không phải vì người sáng lập thiếu can đảm. Chúng thất bại vì không ai nói thật đúng lúc. IdeaVerdict lấp đầy khoảng trống đó — sự thật khó nghe mà bạn bè bạn không nói, chúng tôi sẽ nói.",
  'aboutUs.belief1a': "Chúng tôi không bán sự cường điệu.",
  'aboutUs.belief1b': "Chúng tôi bán tín hiệu thị trường.",
  'aboutUs.belief2a': "Chúng tôi không bán động lực.",
  'aboutUs.belief2b': "Chúng tôi bán phân tích rõ ràng về nhu cầu, cạnh tranh và tính khả thi.",
  'aboutUs.mission1': "Công việc của chúng tôi không phải làm cho ý tưởng của bạn trông đẹp.",
  'aboutUs.mission2': "Công việc của chúng tôi là cho bạn biết liệu nó có thực sự đẹp hay không.",
  'aboutUs.analysis':
    "IdeaVerdict kiểm chứng ý tưởng dựa trên những thứ quan trọng — cấu trúc thị trường, nhu cầu thực, cạnh tranh, vốn cần thiết, thời gian để có doanh thu, khả năng mở rộng. Không cảm xúc. Không lạc quan. Chỉ phân tích.",
  'aboutUs.failure1': "Phần lớn doanh nghiệp thất bại.",
  'aboutUs.failure2': "Không phải vì những người đứng sau bất tài —",
  'aboutUs.failure3': "mà vì không ai đặt câu hỏi khó đúng lúc.",
  'aboutUs.clarity': "Chúng tôi ở đây để đặt câu hỏi đó.",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Honest.",
  'aboutUs.value3': "Fast.",
  'aboutUs.confirm': "If your idea has substance, we back it.",
  'aboutUs.deny': "If it doesn't, we say it to your face.",
  'aboutUs.noApplause': "No applause.",
  'aboutUs.noSugarcoating': "No sugar-coating.",
  'aboutUs.noTheater': "No theatre.",
  'aboutUs.noHype': "Just the verdict.",
  // Hero Section
  'hero.badge': 'Phán quyết AI trong dưới 60 giây',
  'hero.title1': 'Đừng xây',
  'hero.title2': 'trước khi kiểm tra.',
  'hero.subtitle': 'IdeaVerdict thử thách ý tưởng của bạn như một VC hoài nghi.',
  'hero.subtitleLine2': 'Phán quyết trung thực trong vài giây — không hype, không tâng bốc.',
  'hero.cta': 'Nhận phán quyết của tôi',
  'hero.ctaSecondary': 'Xem cách hoạt động',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Tín dụng mỗi yêu cầu',
  'hero.stat2Value': 'Từ 7',
  'hero.stat2Label': 'Khía cạnh đánh giá',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Trung thực & Riêng tư',

  // Features Section
  'features.title1': 'Dành cho',
  'features.title2': 'nhà sáng lập',
  'features.title3': 'muốn sự thật',
  'features.bullet1.title': 'Phán quyết trung thực trong vài giây',
  'features.bullet1.description':
    'Mạnh, Trung bình hoặc Yếu — kèm lý do đằng sau mỗi đánh giá. Không vỗ tay, không bao biện, không kịch tính.',
  'features.bullet2.title': 'Chấm điểm trên điều thực sự quan trọng',
  'features.bullet2.description':
    'Ý tưởng của bạn được đánh giá theo nhu cầu thực, cạnh tranh, vốn cần thiết, thời gian đến doanh thu và khả năng mở rộng — không phải cảm tính.',
  'features.bullet3.title': 'Từ phán quyết đến triển khai',
  'features.bullet3.description':
    'Chế độ Builder biến ý tưởng được duyệt thành bản brief cho dev: luồng người dùng, tính năng cốt lõi, ghi chú kỹ thuật.',

  // How It Works
  'howItWorks.title': 'Cách hoạt động',
  'howItWorks.subtitle': 'Bốn bước để có sự rõ ràng về ngóc ngách kinh doanh của bạn.',
  'howItWorks.step1Title': 'Chọn gói',
  'howItWorks.step1Desc': 'Starter, Pro hoặc Builder – tùy theo độ sâu của đánh giá.',
  'howItWorks.step2Title': 'Hỏi AI',
  'howItWorks.step2Desc': 'Đặt câu hỏi về ngóc ngách. Mỗi yêu cầu tốn 30 tín dụng.',
  'howItWorks.step3Title': 'Nhận phán quyết trung thực',
  'howItWorks.step3Desc': 'AI đánh giá: Tốt, Trung bình hoặc Kém. Không tô vẽ.',
  'howItWorks.step4Title': 'Đưa ra quyết định',
  'howItWorks.step4Desc': 'Bây giờ bạn biết liệu có đáng để tiến lên hay không.',

  // Pricing
  'pricing.title': 'Bảng giá',
  'pricing.subtitle': 'Chọn gói phù hợp với độ sâu đánh giá của bạn.',
  'pricing.monthly': 'Hàng tháng',
  'pricing.yearly': 'Hàng năm',
  'pricing.yearlyDiscount': 'Đăng ký năm:',
  'pricing.yearlyDiscountValue': '-20% giảm giá',
  'pricing.perMonth': 'mỗi tháng',
  'pricing.selectPlan': 'Chọn Gói',
  'pricing.mostPopular': 'Phổ biến nhất',
  'pricing.footer':
    'Tất cả giá bằng CHF. Tín dụng chỉ được trừ cho phản hồi AI thành công.',

  
  // Pricing Features
  'pricing.feature1': 'Trò chuyện Miễn phí (không có biểu mẫu)',
  'pricing.feature2': 'Logic thị trường & đánh giá trung thực',
  'pricing.feature3': 'Lịch sử trò chuyện liên tục',
  'pricing.feature4': 'Nhiều phiên trò chuyện song song',
  'pricing.feature5': 'Hoàn toàn đa ngôn ngữ',
  'pricing.feature6': 'Sử dụng dựa trên tín dụng',
  'pricing.feature7': 'Thiết lập lại hàng tháng',
  'pricing.feature8': 'Phân tích thị trường',
  'pricing.feature9': 'Tóm tắt',
  'pricing.feature10': 'Điểm mạnh',
  'pricing.feature11': 'Điểm yếu',
  'pricing.feature12': 'Cơ hội',
  'pricing.feature13': 'Rủi ro',
  'pricing.feature14': 'Đề xuất',
  'pricing.feature15': 'Tải xuống PDF',
  'pricing.feature16': 'Không có bản tóm tắt dành cho nhà phát triển',
  'pricing.feature17': 'Chế độ Trình tạo: Bản tóm tắt dành cho nhà phát triển',
  'pricing.feature18': 'Nhận xét có cấu trúc',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Truy cập chatbot AI ngóc ngách',
  'pricing.starter.credits': '2.500 Tín dụng mỗi tháng',
  'pricing.starter.feature1': 'Tạo ý tưởng ngóc ngách',
  'pricing.starter.feature2': 'Tinh chỉnh ngóc ngách',
  'pricing.starter.feature3': 'Kiểm tra thực tế thị trường',
  'pricing.starter.feature4': 'Đánh giá cạnh tranh',
  'pricing.starter.feature5': 'Đánh giá thời gian',
  'pricing.starter.feature6': 'Phán quyết trung thực',
  'pricing.starter.feature7': 'Phiên riêng tư',
  'pricing.starter.feature8': 'Lịch sử & xuất',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Truy cập chatbot AI ngóc ngách',
  'pricing.pro.credits': '5.000 Tín dụng mỗi tháng',
  'pricing.pro.feature1': 'Tất cả tính năng của Starter',
  'pricing.pro.feature2': 'Thêm tín dụng cho đánh giá chuyên sâu',
  'pricing.pro.feature3': 'Đề xuất cải tiến',
  'pricing.pro.feature4': 'Ngóc ngách thay thế',
  'pricing.pro.feature5': 'Phân tích thị trường chi tiết',
  'pricing.pro.feature6': 'Hỗ trợ ưu tiên',
  'pricing.pro.feature7': 'Bộ lọc nâng cao',
  'pricing.pro.feature8': 'Phiên yêu thích',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Toàn bộ tính năng + chế độ Builder",
  'pricing.builder.credits': "10.000 credit mỗi tháng",
  'pricing.builder.feature1': 'Tất cả tính năng Pro',
  'pricing.builder.feature2': 'Yêu cầu AI không giới hạn',
  'pricing.builder.feature3': 'Chế độ Builder: Hướng dẫn cho nhà phát triển',
  'pricing.builder.feature4': 'Tổng quan dự án có cấu trúc',
  'pricing.builder.feature5': 'Luồng người dùng & tính năng cốt lõi',
  'pricing.builder.feature6': 'Ghi chú kỹ thuật',
  'pricing.builder.feature7': 'Xác định phi-mục tiêu',
  'pricing.builder.feature8': 'Giới hạn tỷ lệ sử dụng hợp lý',
  'pricing.builder.limitNote': 'Giới hạn sử dụng hợp lý',
  'pricing.monthlyReset': 'Đặt lại hàng tháng',

  // Modal
  'pricing.modal.selected': 'đã chọn',
  'pricing.modal.comingSoon':
    'Đăng ký và xử lý thanh toán sẽ sớm khả dụng.',
  'pricing.modal.patience':
    'Chúng tôi đang làm việc để cung cấp cho bạn trải nghiệm an toàn và liền mạch. Vui lòng kiên nhẫn.',
  'pricing.modal.understood': 'Đã hiểu',

  // FAQ
  'faq.title': "Câu hỏi trước khi bạn tin vào phán quyết",
  'faq.subtitle': 'Được trả lời một cách trung thực & phê phán.',
  'faq.q1': "AI thực sự thẳng thắn đến mức nào?",
  'faq.a1': "Tàn nhẫn. Chúng tôi đã tinh chỉnh nó để chỉ ra ý tưởng yếu, thị trường đông đúc và những con số phi thực tế. Nếu ý tưởng của bạn dở, nó sẽ nói thẳng.",
  'faq.q2': "Tôi nhận được gì với bản dùng thử miễn phí?",
  'faq.a2': "Phán quyết đầy đủ, tất cả chỉ số, tất cả rủi ro. Không cần thẻ tín dụng. Báo cáo Builder (PDF 25–75 trang) cần gói trả phí.",
  'faq.q3': "Vì sao dùng credit thay vì không giới hạn?",
  'faq.a3': "Mỗi phán quyết chạy phân tích AI thật với tìm kiếm web. Việc đó tốn kém với chúng tôi. Credit giữ cho giá cả công bằng — ai dùng nhiều thì trả nhiều.",
  'faq.q4': "Tôi có thể tin dữ liệu thị trường không?",
  'faq.a4': "Chúng tôi lấy dữ liệu từ nguồn công khai, trang đối thủ và xu hướng tìm kiếm. Khi có thể, chúng tôi trích nguồn. Chúng tôi không bịa số — nếu không biết, chúng tôi nói là không biết.",
  'faq.q5': "Báo cáo Builder là gì?",
  'faq.a5': "PDF 25/50/75 trang (tùy gói) gồm kiến trúc, ngăn xếp công nghệ, mô hình tài chính, kế hoạch tiếp cận thị trường và sổ đăng ký rủi ro. Được thiết kế để bạn có thể giao cho lập trình viên hoặc nhà đầu tư.",
  'faq.q6': "Tôi có thể hủy bất cứ lúc nào không?",
  'faq.a6': "Có. Không hợp đồng dài hạn. Hủy ngay trong tài khoản của bạn. Bạn giữ quyền truy cập đến hết kỳ thanh toán.",
  'faq.q7': "Các bạn có lưu ý tưởng của tôi không?",
  'faq.a7': "Có — trong tài khoản của bạn, để bạn có thể xem lại. Chúng tôi không bán hay chia sẻ chúng. Xóa bất cứ lúc nào.",
  'faq.q8': "Hỗ trợ những ngôn ngữ nào?",
  'faq.a8': "Hơn hai mươi. Phán quyết tự động thích ứng theo ngôn ngữ của bạn.",
  'faq.q9': "Có hoàn tiền không?",
  'faq.a9': "Hoàn tiền trong 7 ngày cho tháng trả phí đầu tiên nếu bạn chưa dùng Báo cáo Builder.",
  'faq.q10': "Ai đứng sau IdeaVerdict?",
  'faq.a10': "Một nhóm nhỏ người Thụy Sĩ đã quá mệt mỏi khi thấy các nhà sáng lập lãng phí hàng năm trời cho những ý tưởng đáng lẽ phải bị loại bỏ ngay từ tuần đầu.",
  // Footer
  'footer.description':
    'IdeaVerdict không ở đây để bạn cảm thấy tốt. Nó ở đây để giúp bạn quyết định đúng.',
  'footer.product': 'Sản phẩm',
  'footer.aiAssistant': 'Trợ lý AI',
  'footer.howItWorks': 'Cách hoạt động',
  'footer.pricing': 'Bảng giá',
  'footer.faq': 'Câu hỏi thường gặp',
  'footer.legal': 'Pháp lý',
  'footer.privacy': 'Quyền riêng tư',
  'footer.terms': 'Điều khoản',
  'footer.imprint': 'Thông tin xuất bản',
  'footer.support': 'Hỗ trợ',
  'footer.contact': 'Liên hệ',
  'footer.documentation': 'Tài liệu',
  'footer.copyright': '© 2026 IdeaVerdict. Đã đăng ký bản quyền.',

  // AI Assistant
  'aiAssistant.title': 'Trợ lý Ngóc ngách AI',
  'aiAssistant.subtitle': 'Hỏi về ngóc ngách',
  'aiAssistant.welcomeMessage':
    'Chào! Hãy mô tả ý tưởng của bạn hoặc hỏi tôi về một ngóc ngách. Tôi sẽ đánh giá rõ ràng và trung thực cho bạn.',
  'aiAssistant.demoResponse':
    'Đây là bản demo. Để nhận được đánh giá AI thực tế, vui lòng đăng ký và chọn gói.',
  'aiAssistant.placeholder': 'Mô tả ý tưởng của bạn...',

  // Header & Sidebar
  'dashboard.header.title': 'Bảng điều khiển',
  'dashboard.header.aiAssistant': 'Trợ lý AI của bạn',
  'header.logout': 'Đăng xuất',
  'dashboard.sidebar.overview': 'Tổng quan',
  'dashboard.sidebar.aiChat': 'Trợ lý AI',
  'dashboard.sidebar.newAnalysis': 'Trợ lý AI',
  'dashboard.sidebar.history': 'Lịch sử',
  'dashboard.sidebar.credits': 'Tín dụng',
  'dashboard.sidebar.settings': 'Cài đặt',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Chào mừng trở lại, {{name}}',
  'dashboard.overview.subtitle':
    'Đây là tổng quan nhanh về hoạt động của bạn',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Tín dụng còn lại',
  'dashboard.stats.totalAnalyses': 'Tổng số phân tích',
  'dashboard.stats.goodRatings': 'Đánh giá tích cực',
  'dashboard.stats.nextReset': 'Đặt lại sau',
  'dashboard.stats.days': 'ngày',

  // Quick Actions
  'dashboard.quickActions.title': 'Thao tác nhanh',
  'dashboard.quickActions.checkNewIdea': 'Kiểm tra ý tưởng',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Phân tích một ý tưởng kinh doanh hiện có',
  'dashboard.quickActions.generateIdea': 'Tạo ý tưởng',
  'dashboard.quickActions.generateIdeaDesc':
    'Tìm một ngóc ngách sinh lợi mới',
  'dashboard.quickActions.builderBriefing': 'Hướng dẫn Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Biến ý tưởng thành hướng dẫn sẵn sàng cho nhà phát triển',
  'dashboard.quickActions.premiumOnly': 'Chỉ dành cho Builder',

  // Chat Header
  'chat.title': 'Trợ lý Ngóc ngách AI',
  'chat.subtitle':
    'Hỏi câu hỏi về ngóc ngách. Tôi đánh giá một cách phê phán và trung thực.',
  'chat.creditsLabel': 'Tín dụng',

  // Chat Welcome
  'chat.welcomeTitle': 'Chào mừng đến với Trợ lý Ngóc ngách AI',
  'chat.welcomeDesc':
    'Mô tả ý tưởng của bạn hoặc hỏi về một ngóc ngách. Tôi sẽ đánh giá trung thực: Tốt, Trung bình hoặc Kém.',
  'chat.aiWelcome':
    'Chào! Hãy mô tả ý tưởng của bạn hoặc hỏi tôi về một ngóc ngách. Tôi sẽ đánh giá rõ ràng và trung thực cho bạn.',

  // Chat Suggestions
  'chat.suggestion1': 'Tôi muốn xây dựng công cụ SaaS cho freelancer quản lý hóa đơn. Đây có phải ngóc ngách tốt không?',
  'chat.suggestion2': 'Tìm cho tôi kinh doanh online ít cạnh tranh có thể bắt đầu với $500 mà không cần lập trình.',
  'chat.suggestion3': 'Đánh giá: ứng dụng lập kế hoạch bữa ăn AI cho phụ huynh bận rộn có hạn chế ăn kiêng.',
  'chat.suggestion4': 'Tôi muốn bán template số trên Etsy cho chủ doanh nghiệp nhỏ. Phân tích ngóc ngách này trung thực.',

  // Chat Actions
  'chat.newConversation': 'Cuộc trò chuyện mới',
  'chat.today': 'Hôm nay',
  'chat.yesterday': 'Hôm qua',
  'chat.thisWeek': 'Tuần này',
  'chat.thisMonth': 'Tháng này',
  'chat.older': 'Cũ hơn',
  'chat.messages': 'tin nhắn',
  'chat.renameConversation': 'Đổi tên',
  'chat.deleteConversation': 'Xóa',
  'chat.cancel': 'Hủy',
  'chat.rename': 'Đổi tên',
  'chat.delete': 'Xóa',
  'chat.favorite': 'Thêm vào yêu thích',
  'chat.unfavorite': 'Xóa khỏi yêu thích',
  'chat.searchSessions': 'Tìm kiếm cuộc trò chuyện...',
  'chat.noResults': 'Không tìm thấy kết quả',
  'chat.noSessions': 'Chưa có cuộc trò chuyện nào',
  'chat.enterNewName': 'Nhập tên mới...',
  'chat.deleteConfirmMessage':
    'Bạn có chắc chắn muốn xóa cuộc trò chuyện này? Hành động này không thể hoàn tác.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Nhập câu hỏi của bạn… (tốn 30 tín dụng)',
  'chat.send': 'Gửi',
  'chat.voice': 'Nói',
  'chat.listeningPlaceholder': 'Tôi đang nghe... Hãy nói ngay bây giờ.',
  'chat.stopListening': 'Dừng nghe',
  'chat.recording': 'Đang ghi âm...',
  'chat.speechNotSupported': 'Trình duyệt của bạn không hỗ trợ nhận dạng giọng nói.',
  'chat.microphonePermissionDenied': 'Truy cập micrô bị từ chối. Vui lòng cho phép truy cập trong cài đặt trình duyệt.',
  'chat.errorNotEnoughCredits':
    'Không đủ tín dụng. Vui lòng nâng cấp gói của bạn hoặc đợi lần đặt lại tiếp theo.',
  'chat.errorAiFailed': 'Phản hồi AI thất bại. Không có tín dụng nào bị trừ.',
  'chat.errorRateLimit': 'Quá nhiều yêu cầu. Vui lòng đợi một lát.',

  // Ratings
  'rating.good': 'Tốt',
  'rating.medium': 'Trung bình',
  'rating.bad': 'Kém',

  // Auth Page
  'auth.branding.headline1': 'Không phải ý tưởng nào cũng tốt.',
  'auth.branding.headline2': 'Chúng tôi nói với bạn một cách trung thực.',
  'auth.branding.subtitle':
    'Một AI quyết định cho các ngóc ngách kinh doanh. Rõ ràng. Phê phán. Không tô vẽ.',
  'auth.benefits.privacy.title': '100% Riêng tư',
  'auth.benefits.privacy.desc':
    'Ý tưởng của bạn hoàn toàn được giữ riêng tư và an toàn.',
  'auth.benefits.honest.title': 'AI Trung thực',
  'auth.benefits.honest.desc':
    'Không tô vẽ – chỉ phản hồi rõ ràng, phê phán.',
  'auth.benefits.fast.title': 'Kết quả Nhanh',
  'auth.benefits.fast.desc': 'Có được sự rõ ràng về ngóc ngách của bạn trong vài phút.',
  'auth.trust.users': 'Người dùng Hoạt động',
  'auth.trust.ideas': 'Ý tưởng Đã Phân tích',
  'auth.trust.rating': 'Đánh giá Người dùng',
  'auth.login.title': 'Đăng nhập',
  'auth.login.headline': 'Chào mừng trở lại',
  'auth.login.subtitle': 'Đăng nhập để tiếp tục hành trình của bạn.',
  'auth.login.forgotPassword': 'Quên mật khẩu?',
  'auth.login.submit': 'Đăng nhập',
  'auth.login.noAccount': 'Chưa có tài khoản?',
  'auth.login.signUp': 'Đăng ký',
  'auth.register.title': 'Đăng ký',
  'auth.register.headline': 'Tạo tài khoản của bạn',
  'auth.register.subtitle':
    'Bắt đầu phân tích ý tưởng kinh doanh của bạn ngay hôm nay.',
  'auth.register.submit': 'Tạo tài khoản',
  'auth.register.hasAccount': 'Đã có tài khoản?',
  'auth.register.signIn': 'Đăng nhập',
  'auth.fields.name': 'Họ và tên',
  'auth.fields.email': 'Địa chỉ Email',
  'auth.fields.password': 'Mật khẩu',
  'auth.fields.confirmPassword': 'Xác nhận Mật khẩu',
  'auth.fields.selectPlan': 'Chọn gói của bạn',
  'auth.fields.testCode': 'Đăng nhập và dùng thử miễn phí',
  'auth.placeholders.name': 'Nhập tên của bạn',
  'auth.placeholders.email': 'Nhập email của bạn',
  'auth.placeholders.password': 'Nhập mật khẩu của bạn',
  'auth.placeholders.confirmPassword': 'Xác nhận mật khẩu của bạn',
  'auth.placeholders.testCode': 'Nhập mã dùng thử',
  'auth.terms.accept': 'Tôi chấp nhận',
  'auth.terms.terms': 'Điều khoản & Điều kiện',
  'auth.privacy.accept': 'Tôi chấp nhận',
  'auth.privacy.policy': 'Chính sách Quyền riêng tư',
  'auth.errors.nameRequired': 'Tên là bắt buộc',
  'auth.errors.emailRequired': 'Email là bắt buộc',
  'auth.errors.emailInvalid': 'Vui lòng nhập email hợp lệ',
  'auth.errors.passwordRequired': 'Mật khẩu là bắt buộc',
  'auth.errors.passwordLength': 'Mật khẩu phải có ít nhất 8 ký tự',
  'auth.errors.passwordMismatch': 'Mật khẩu không khớp',
  'auth.errors.invalidCode': 'Mã không hợp lệ hoặc đã hết hạn',
  'auth.errors.registrationCodeOnly': 'Mã này chỉ dành cho đăng ký',
  'auth.errors.verificationFailed': 'Lỗi xác minh mã. Vui lòng thử lại.',
  'auth.loading': 'Vui lòng chờ...',
  'auth.or': 'hoặc tiếp tục với',
  'auth.social.google': 'Tiếp tục với Google',
  'auth.social.apple': 'Tiếp tục với Apple',
  'auth.actions.verify': 'Xác minh',
  'auth.testCode.activated': 'Mã dùng thử đã được kích hoạt!',
  'auth.testCode.days': 'ngày',
  'auth.testCode.months': 'tháng',
  'auth.testCode.freeAccess': 'truy cập miễn phí',
  'auth.testCode.credits': 'tín dụng',

  // Email Verification
  'auth.verification.title': 'Xác minh Email',
  'auth.verification.headline': 'Kiểm tra hộp thư đến của bạn',
  'auth.verification.subtitle': 'Chúng tôi đã gửi mã xác minh đến:',
  'auth.verification.codeLabel': 'Mã xác minh',
  'auth.verification.codePlaceholder': 'Nhập mã 6 chữ số',
  'auth.verification.submit': 'Xác minh Email',
  'auth.verification.resend': 'Gửi lại mã',
  'auth.verification.resendIn': 'Gửi lại sau',
  'auth.verification.seconds': 'giây',
  'auth.verification.success': 'Email đã được xác minh thành công!',
  'auth.verification.error': 'Mã không hợp lệ. Vui lòng thử lại.',
  'auth.verification.expired': 'Mã đã hết hạn. Vui lòng yêu cầu mã mới.',
  'auth.verification.sent': 'Mã mới đã được gửi!',
  'auth.verification.checkSpam':
    'Không nhận được? Hãy kiểm tra thư mục thư rác của bạn.',

  // Forgot Password
  'auth.forgot.title': 'Quên Mật khẩu',
  'auth.forgot.headline': 'Đặt lại mật khẩu của bạn',
  'auth.forgot.subtitle':
    'Nhập địa chỉ email của bạn và chúng tôi sẽ gửi cho bạn liên kết đặt lại.',
  'auth.forgot.submit': 'Gửi Liên kết Đặt lại',
  'auth.forgot.backToLogin': 'Quay lại đăng nhập',
  'auth.forgot.success': 'Email đã được gửi!',
  'auth.forgot.successMessage':
    'Chúng tôi đã gửi cho bạn một email có hướng dẫn để đặt lại mật khẩu.',
  'auth.forgot.checkInbox': 'Kiểm tra hộp thư đến của bạn',

  // Reset Password
  'auth.reset.title': 'Mật khẩu Mới',
  'auth.reset.headline': 'Đặt mật khẩu mới',
  'auth.reset.subtitle': 'Nhập mật khẩu mới của bạn.',
  'auth.reset.newPassword': 'Mật khẩu Mới',
  'auth.reset.confirmNewPassword': 'Xác nhận Mật khẩu Mới',
  'auth.reset.submit': 'Đổi Mật khẩu',
  'auth.reset.success': 'Mật khẩu đã được thay đổi thành công!',
  'auth.reset.successMessage':
    'Bạn có thể đăng nhập bằng mật khẩu mới của mình.',
  'auth.reset.loginNow': 'Đăng nhập ngay',

  // Legal Pages
  'legal.backToAuth': 'Quay lại đăng nhập',
  'legal.allRightsReserved': 'Đã đăng ký bản quyền.',

  // Terms Page
  'legal.terms.title': 'Điều khoản và Điều kiện',
  'legal.terms.lastUpdated': 'Cập nhật lần cuối',
  'legal.terms.section1.title': '1. Phạm vi',
  'legal.terms.section1.content':
    'Các Điều khoản và Điều kiện này áp dụng cho tất cả hợp đồng giữa IdeaVerdict (sau đây gọi là "Nhà cung cấp") và người dùng (sau đây gọi là "Khách hàng") liên quan đến việc sử dụng nền tảng phân tích ngóc ngách hỗ trợ AI.',
  'legal.terms.section2.title': '2. Mô tả Dịch vụ',
  'legal.terms.section2.content':
    'Nhà cung cấp cung cấp một nền tảng dựa trên AI để phân tích và đánh giá các ý tưởng và ngóc ngách kinh doanh. Các dịch vụ bao gồm:',
  'legal.terms.section2.item1': 'Phân tích ý tưởng kinh doanh hỗ trợ AI',
  'legal.terms.section2.item2': 'Đánh giá tiềm năng thị trường và cạnh tranh',
  'legal.terms.section2.item3': 'Tạo đề xuất ngóc ngách',
  'legal.terms.section2.item4': 'Tạo hướng dẫn cho nhà phát triển (gói Builder)',
  'legal.terms.section3.title': '3. Ký kết Hợp đồng và Đăng ký',
  'legal.terms.section3.content':
    'Hợp đồng được ký kết thông qua đăng ký trên nền tảng và lựa chọn gói. Khách hàng xác nhận:',
  'legal.terms.section3.item1': 'Đủ tuổi trưởng thành và có đầy đủ năng lực pháp lý',
  'legal.terms.section3.item2': 'Cung cấp thông tin trung thực trong quá trình đăng ký',
  'legal.terms.section3.item3': 'Lưu trữ an toàn thông tin đăng nhập',
  'legal.terms.section4.title': '4. Tín dụng và Thanh toán',
  'legal.terms.section4.content':
    'Việc sử dụng các tính năng AI dựa trên hệ thống tín dụng. Mỗi truy vấn AI tốn 30 tín dụng. Tín dụng chỉ được trừ khi có phản hồi thành công. Tín dụng chưa sử dụng sẽ hết hạn vào cuối kỳ thanh toán và không được hoàn lại.',
  'legal.terms.section5.title': '5. Tuyên bố Miễn trừ',
  'legal.terms.section5.content':
    'Các đánh giá của AI chỉ đóng vai trò hỗ trợ quyết định và không đảm bảo thành công trong kinh doanh. Nhà cung cấp không chịu trách nhiệm về các quyết định được đưa ra dựa trên phân tích của AI. Trách nhiệm đối với hành vi cố ý và sơ suất nghiêm trọng vẫn không bị ảnh hưởng.',
  'legal.terms.section6.title': '6. Bảo vệ Dữ liệu và Bảo mật',
  'legal.terms.section6.content':
    'Tất cả các ý tưởng kinh doanh được gửi đều được xử lý bảo mật và không được chia sẻ với bên thứ ba. Việc xử lý dữ liệu cá nhân được thực hiện theo Chính sách Quyền riêng tư của chúng tôi và luật bảo vệ dữ liệu hiện hành.',
  'legal.terms.section7.title': '7. Chấm dứt',
  'legal.terms.section7.content':
    'Khách hàng có thể hủy đăng ký của mình bất kỳ lúc nào vào cuối kỳ thanh toán hiện tại. Trong trường hợp vi phạm các Điều khoản này, Nhà cung cấp có quyền chặn quyền truy cập vào nền tảng.',
  'legal.terms.section8.title': '8. Điều khoản Cuối cùng',
  'legal.terms.section8.content':
    'Luật Thụy Sĩ được áp dụng. Nơi tài phán là Zurich, Thụy Sĩ. Nếu các điều khoản riêng lẻ của Điều khoản này không hợp lệ, hiệu lực của các điều khoản còn lại vẫn không bị ảnh hưởng.',
  'legal.terms.contact.title': 'Câu hỏi về Điều khoản?',
  'legal.terms.contact.content':
    'Nếu bạn có câu hỏi về Điều khoản và Điều kiện này, vui lòng liên hệ với chúng tôi tại:',

  // Privacy Page
  'legal.privacy.title': 'Chính sách Quyền riêng tư',
  'legal.privacy.section1.title': '1. Đơn vị Kiểm soát Dữ liệu',
  'legal.privacy.section1.content':
    'Đơn vị kiểm soát dữ liệu cho trang web này là IdeaVerdict, Zurich, Thụy Sĩ. Chúng tôi coi trọng việc bảo vệ dữ liệu cá nhân của bạn và xử lý dữ liệu cá nhân của bạn một cách bảo mật và tuân thủ các quy định bảo vệ dữ liệu theo luật định.',
  'legal.privacy.section2.title': '2. Dữ liệu Được Thu thập',
  'legal.privacy.section2.content':
    'Chúng tôi thu thập và xử lý các dữ liệu cá nhân sau:',
  'legal.privacy.section2.item1':
    'Dữ liệu đăng ký: Tên, địa chỉ email, mật khẩu (đã mã hóa)',
  'legal.privacy.section2.item2':
    'Dữ liệu sử dụng: Địa chỉ IP, loại trình duyệt, thời gian truy cập',
  'legal.privacy.section2.item3':
    'Ý tưởng kinh doanh và truy vấn ngóc ngách (được lưu trữ ẩn danh)',
  'legal.privacy.section2.item4':
    'Thông tin thanh toán (thông qua nhà cung cấp bên thứ ba an toàn)',
  'legal.privacy.section3.title': '3. Mục đích Xử lý Dữ liệu',
  'legal.privacy.section3.content':
    'Dữ liệu của bạn được sử dụng cho các mục đích sau:',
  'legal.privacy.section3.item1':
    'Cung cấp và cải thiện các dịch vụ AI của chúng tôi',
  'legal.privacy.section3.item2':
    'Quản lý tài khoản và xác thực',
  'legal.privacy.section3.item3':
    'Thanh toán và xử lý giao dịch',
  'legal.privacy.section4.title': '4. Bảo mật Dữ liệu',
  'legal.privacy.section4.content':
    'Chúng tôi thực hiện các biện pháp bảo mật kỹ thuật và tổ chức để bảo vệ dữ liệu của bạn khỏi bị thao túng, mất mát, phá hủy hoặc truy cập trái phép. Tất cả quá trình truyền dữ liệu đều được mã hóa qua SSL/TLS.',
  'legal.privacy.section5.title': '5. Bảo mật Ý tưởng Kinh doanh của Bạn',
  'legal.privacy.section5.content':
    'Các ý tưởng kinh doanh và truy vấn ngóc ngách bạn gửi được xử lý hết sức bảo mật. Chúng không được chia sẻ với bên thứ ba, không được sử dụng cho mục đích đào tạo và có thể bị xóa hoàn toàn theo yêu cầu. Ý tưởng của bạn thuộc về bạn.',
  'legal.privacy.section6.title': '6. Quyền của Bạn',
  'legal.privacy.section6.content':
    'Bạn có các quyền sau đây liên quan đến dữ liệu cá nhân của mình:',
  'legal.privacy.section6.item1': 'Quyền truy cập dữ liệu đã lưu trữ',
  'legal.privacy.section6.item2': 'Quyền sửa chữa dữ liệu không chính xác',
  'legal.privacy.section6.item3': 'Quyền xóa dữ liệu của bạn',
  'legal.privacy.section6.item4': 'Quyền chuyển đổi dữ liệu',
  'legal.privacy.section7.title': '7. Cookie',
  'legal.privacy.section7.content':
    'Trang web của chúng tôi chỉ sử dụng cookie cần thiết về mặt kỹ thuật cho mục đích xác thực và quản lý phiên. Chúng tôi không sử dụng cookie theo dõi hoặc công cụ phân tích của bên thứ ba nếu không có sự đồng ý rõ ràng của bạn.',
  'legal.privacy.section8.title': '8. Thay đổi Chính sách Quyền riêng tư này',
  'legal.privacy.section8.content':
    'Chúng tôi có quyền điều chỉnh chính sách quyền riêng tư này để tuân thủ các yêu cầu pháp lý đã thay đổi hoặc khi có thay đổi đối với dịch vụ. Phiên bản hiện tại luôn có thể được tìm thấy trên trang này.',
  'legal.privacy.contact.title': 'Câu hỏi về Quyền riêng tư?',
  'legal.privacy.contact.content':
    'Nếu bạn có câu hỏi về việc xử lý dữ liệu cá nhân của mình, vui lòng liên hệ với chúng tôi tại:',

  'auth.passwordStrength.label': 'Độ mạnh mật khẩu',
  'auth.passwordStrength.weak': 'Yếu',
  'auth.passwordStrength.medium': 'Trung bình',
  'auth.passwordStrength.strong': 'Mạnh',
  'auth.passwordStrength.veryStrong': 'Rất mạnh',
  'auth.passwordStrength.minLength': 'Tối thiểu 8 ký tự',
  'auth.passwordStrength.uppercase': 'Chữ hoa',
  'auth.passwordStrength.number': 'Số',
  'auth.passwordStrength.special': 'Ký tự đặc biệt',

  trial: {
    subtitle: 'Dùng thử Miễn phí',
    upgrade: 'Nâng cấp Ngay',
    creditsRemaining: 'tín dụng còn lại',
    inputHint: 'Phiên bản dùng thử - Không có lịch sử trò chuyện',
    banner: {
      title: 'Đang Dùng thử 7 Ngày',
      remaining: 'còn {{days}} ngày',
      credits: 'tín dụng khả dụng',
      upgradeNow: 'Nâng cấp Ngay',
    },
    welcome: {
      title: 'Chào mừng đến với Bản dùng thử Miễn phí!',
      desc: 'Hãy dùng thử trợ lý AI của chúng tôi miễn phí trong 7 ngày với 100 tín dụng. Đặt câu hỏi và khám phá các khả năng!',
    },
    info: {
      title: 'Giới hạn Dùng thử',
      credits: '100 tín dụng trong 7 ngày',
      noHistory: 'Không có lịch sử trò chuyện',
      noSettings: 'Tính năng giới hạn',
      upgrade: 'Nâng cấp để có đầy đủ tính năng',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Cài đặt',
  'settings.subtitle': 'Quản lý tài khoản và tùy chọn của bạn',
  'settings.backToOverview': 'Quay lại tổng quan',
  'settings.subscriptionLink': 'Đăng ký & Thanh toán',
  'settings.saved': 'Đã lưu thay đổi thành công',
  'settings.changesSaved': 'Đã lưu thay đổi',
  'settings.saveChanges': 'Lưu thay đổi',
  'settings.dataExported': 'Đã xuất dữ liệu thành công',

  // Tabs
  'settings.tabs.profile': 'Hồ sơ',
  'settings.tabs.preferences': 'Tùy chọn',
  'settings.tabs.notifications': 'Thông báo',
  'settings.tabs.account': 'Tài khoản & Gói',

  // Profile
  'settings.profile.changePhoto': 'Đổi ảnh',
  'settings.profile.photoHint': 'JPG, PNG hoặc GIF (tối đa 2MB)',
  'settings.profile.uploading': 'Đang tải lên...',
  'settings.profile.photoUpdated': 'Ảnh hồ sơ đã được cập nhật!',
  'settings.profile.name': 'Tên',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Điện thoại',
  'settings.profile.changePassword': 'Đổi mật khẩu',
  'settings.profile.currentPassword': 'Mật khẩu hiện tại',
  'settings.profile.newPassword': 'Mật khẩu mới',
  'settings.profile.confirmPassword': 'Xác nhận mật khẩu',

  // Preferences
  'settings.preferences.language': 'Ngôn ngữ',
  'settings.preferences.chooseLanguage': 'Chọn ngôn ngữ',
  'settings.preferences.timezone': 'Múi giờ',
  'settings.preferences.currency': 'Tiền tệ',

  // Notifications
  'settings.notifications.emailTitle': 'Thông báo Email',
  'settings.notifications.email.analysis': 'Phân tích hoàn tất',
  'settings.notifications.email.analysisDesc': 'Nhận email khi phân tích của bạn sẵn sàng',
  'settings.notifications.email.credits': 'Cập nhật tín dụng',
  'settings.notifications.email.creditsDesc': 'Thông báo về tín dụng và đặt lại',
  'settings.notifications.email.billing': 'Hóa đơn & Thanh toán',
  'settings.notifications.email.billingDesc': 'Thông báo về hóa đơn và thay đổi gói',
  'settings.notifications.email.newsletter': 'Bản tin',
  'settings.notifications.email.newsletterDesc': 'Mẹo, cập nhật và tính năng mới',
  'settings.notifications.pushTitle': 'Thông báo Đẩy',
  'settings.notifications.push.analysis': 'Phân tích hoàn tất',
  'settings.notifications.push.analysisDesc': 'Thông báo trình duyệt khi phân tích sẵn sàng',
  'settings.notifications.push.credits': 'Cảnh báo tín dụng',
  'settings.notifications.push.creditsDesc': 'Cảnh báo khi số dư tín dụng thấp',

  // Account
  'settings.account.currentSubscription': 'Đăng ký Hiện tại',
  'settings.account.plan': 'Gói',
  'settings.account.price': 'Giá',
  'settings.account.nextBilling': 'Thanh toán tiếp theo',
  'settings.account.manageSubscription': 'Quản lý đăng ký & thanh toán',
  'settings.account.dataPrivacy': 'Dữ liệu & Quyền riêng tư',
  'settings.account.exportData': 'Xuất dữ liệu',
  'settings.account.deleteAccount': 'Xóa tài khoản',

  // Delete Modal
  'settings.deleteModal.title': 'Xóa tài khoản?',
  'settings.deleteModal.subtitle': 'Tất cả dữ liệu sẽ bị xóa vĩnh viễn.',
  'settings.deleteModal.warning1': 'Tất cả phân tích và dữ liệu sẽ bị xóa',
  'settings.deleteModal.warning2': 'Đăng ký đang hoạt động sẽ bị hủy ngay lập tức',
  'settings.deleteModal.warning3': 'Không thể hoàn tiền',
  'settings.deleteModal.confirmLabel': 'Nhập "{{word}}" để xác nhận *',
  'settings.deleteModal.cancel': 'Hủy',
  'settings.deleteModal.confirm': 'Xóa tài khoản',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Quay lại tổng quan',
  'sub.settings': 'Cài đặt',
  'sub.title': 'Đăng ký & Thanh toán',
  'sub.subtitle': 'Quản lý đăng ký, phương thức thanh toán và hóa đơn của bạn',
  'sub.tab.overview': 'Tổng quan',
  'sub.tab.payment': 'Phương thức Thanh toán',
  'sub.tab.billing': 'Địa chỉ Thanh toán',
  'sub.tab.history': 'Lịch sử Thanh toán',
  'sub.memberSince': 'Thành viên từ',
  'sub.perMonth': 'mỗi tháng',
  'sub.baseCHF': '(CHF {{amount}} cơ bản)',
  'sub.nextBilling': 'Thanh toán tiếp theo',
  'sub.creditsUsed': 'Tín dụng đã sử dụng',
  'sub.paymentMethod': 'Phương thức thanh toán',
  'sub.creditUsage': 'Sử dụng tín dụng',
  'sub.changePlan': 'Đổi gói',
  'sub.reactivate': 'Kích hoạt lại',
  'sub.cancelSub': 'Hủy đăng ký',
  'sub.manageCards': 'Quản lý thẻ',
  'sub.downloadInvoices': 'Tải xuống hóa đơn',
  'sub.invoicesAvailable': '{{count}} hóa đơn có sẵn dưới dạng PDF',
  'sub.accountSettings': 'Cài đặt Tài khoản',
  'sub.profileNotifications': 'Hồ sơ, thông báo và hơn thế nữa',
  // Prices in EUR info
  'sub.eurInfo': 'Giá hiển thị bằng',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Tỷ giá:',
  'sub.currentRate': 'Tỷ giá hiện tại',
  // Payment Methods
  'sub.savedCards': 'Thẻ Đã Lưu',
  'sub.newCard': 'Thẻ Mới',
  'sub.default': 'Mặc định',
  'sub.setDefault': 'Đặt làm mặc định',
  'sub.validUntil': 'Hiệu lực đến',
  'sub.noCards': 'Chưa có thẻ nào được lưu',
  'sub.addFirstCard': 'Thêm thẻ đầu tiên',
  'sub.securePayments': 'Thanh toán An toàn',
  'sub.securePaymentsDesc': 'Tất cả dữ liệu thanh toán được truyền mã hóa và lưu trữ an toàn với nhà cung cấp thanh toán của chúng tôi. Chúng tôi không lưu trữ số thẻ đầy đủ.',
  // Billing Address
  'sub.billingAddress': 'Địa chỉ Thanh toán',
  'sub.edit': 'Sửa',
  'sub.name': 'Tên',
  'sub.streetAddress': 'Đường & Số nhà',
  'sub.zip': 'Mã Bưu chính',
  'sub.city': 'Thành phố',
  'sub.country': 'Quốc gia',
  'sub.address': 'Địa chỉ',
  'sub.save': 'Lưu',
  'sub.cancel': 'Hủy',
  'sub.country.switzerland': 'Thụy Sĩ',
  'sub.country.germany': 'Đức',
  'sub.country.austria': 'Áo',
  'sub.country.netherlands': 'Hà Lan',
  'sub.country.belgium': 'Bỉ',
  // Payment History
  'sub.paymentHistory': 'Lịch sử Thanh toán',
  'sub.allInvoicesPDF': 'Tải xuống tất cả hóa đơn dưới dạng PDF với logo',
  'sub.downloadAll': 'Tải xuống tất cả',
  'sub.eurInvoiceNote': 'Hóa đơn luôn được lập bằng CHF. Số tiền EUR hiển thị chỉ mang tính tham khảo.',
  'sub.date': 'Ngày',
  'sub.description': 'Mô tả',
  'sub.net': 'Thuần',
  'sub.vat': 'VAT',
  'sub.total': 'Tổng',
  'sub.status': 'Trạng thái',
  'sub.pdf': 'PDF',
  'sub.invoices': 'hóa đơn',
  'sub.totalAmount': 'Tổng số tiền',
  // Change Plan Modal
  'sub.changePlanTitle': 'Đổi Gói',
  'sub.current': 'Hiện tại',
  'sub.month': '/tháng',
  'sub.showLess': 'Ẩn bớt',
  'sub.showMore': '+{{count}} thêm',
  'sub.switchPlan': 'Chuyển gói',
  'sub.eurPriceNote': 'Giá hiển thị bằng EUR ({{note}}). Thanh toán bằng CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Thực sự hủy đăng ký?',
  'sub.cancelIrreversible': 'Hành động này không thể hoàn tác.',
  'sub.cancelWarning1': 'Tất cả tín dụng còn lại sẽ hết hạn',
  'sub.cancelWarning2': 'Hạ cấp xuống Gói Miễn phí',
  'sub.cancelWarning3': 'Mất tất cả tính năng cao cấp',
  'sub.pauseInstead': 'Thay vào đó: Tạm dừng đăng ký?',
  'sub.pauseDesc': 'Tạm dừng đăng ký của bạn và giữ dữ liệu của bạn.',
  'sub.preferPause': 'Thích tạm dừng hơn',
  'sub.cancelReason': 'Lý do hủy',
  'sub.selectReason': 'Vui lòng chọn...',
  'sub.reason.tooExpensive': 'Quá đắt',
  'sub.reason.notUsing': 'Không sử dụng đủ',
  'sub.reason.missingFeatures': 'Thiếu tính năng',
  'sub.reason.foundAlternative': 'Tìm thấy giải pháp thay thế',
  'sub.reason.other': 'Khác',
  'sub.confirmType': 'Xác nhận: Nhập "CANCEL" *',
  'sub.cancelNow': 'Hủy ngay',
  // Add Card Modal
  'sub.addCardTitle': 'Thêm Thẻ Mới',
  'sub.cardHolder': 'Chủ thẻ *',
  'sub.cardNumber': 'Số thẻ *',
  'sub.expiryDate': 'Ngày hết hạn *',
  'sub.addCard': 'Thêm thẻ',
  // Change Card Modal
  'sub.choosePayment': 'Chọn phương thức thanh toán',
  'sub.active': 'Hoạt động',
  'sub.close': 'Đóng',
  // Toast messages
  'sub.toast.cancelled': 'Đăng ký của bạn đã được hủy vào cuối kỳ thanh toán.',
  'sub.toast.reactivated': 'Đăng ký của bạn đã được kích hoạt lại thành công!',
  'sub.toast.planChanged': 'Đã chuyển đổi gói thành công sang {{plan}}!',
  'sub.toast.defaultChanged': 'Đã thay đổi phương thức thanh toán mặc định.',
  'sub.toast.cannotDeleteDefault': 'Không thể xóa thẻ mặc định.',
  'sub.toast.cardRemoved': 'Thẻ đã được xóa.',
  'sub.toast.fillAll': 'Vui lòng điền vào tất cả các trường.',
  'sub.toast.cardAdded': 'Đã thêm thẻ mới thành công!',
  'sub.toast.billingSaved': 'Đã lưu địa chỉ thanh toán.',
  'sub.toast.invoiceDownloaded': 'Đã tải xuống hóa đơn {{id}}!',
  'sub.toast.pdfError': 'Lỗi tạo PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Không đủ tín dụng',
  'sub.needCredits': 'Bạn cần ít nhất {{count}} tín dụng mỗi câu hỏi.',
  'sub.creditsLow': 'Sắp hết tín dụng',
  'sub.questionsLeft': 'Có thể hỏi {{count}} câu hỏi.',
  'sub.plan': 'Gói',
  'sub.base': 'cơ bản',
  'sub.unlimited': 'Không giới hạn',
  'sub.status.active': 'Hoạt động',
  'sub.status.cancelled': 'Đã hủy',
  'sub.status.paused': 'Tạm dừng',
  'sub.invoice': 'HÓA ĐƠN',
  'sub.from': 'TỪ',
  'sub.to': 'ĐẾN',
  'sub.vatId': 'Mã số VAT',
  'sub.tel': 'Điện thoại',
  'sub.invoiceDate': 'Ngày hóa đơn',
  'sub.invoiceNumber': 'Số hóa đơn',
  'sub.paymentStatus': 'Trạng thái thanh toán',
  'sub.creditCard': 'Thẻ tín dụng',
  'sub.quantity': 'SL',
  'sub.price': 'GIÁ',
  'sub.amount': 'SỐ TIỀN',
  'sub.subtotal': 'Tạm tính',
  'sub.bank': 'Ngân hàng',
  'sub.card': 'Thẻ',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Bảng điều khiển Quản trị',
  'admin.subtitle': 'Trung tâm Điều khiển',
  'admin.superAdmin': 'Siêu Quản trị',
  'admin.logout': 'Đăng xuất',
  'admin.tabs.users': 'Quản lý Người dùng',
  'admin.tabs.downgrades': 'Hạ cấp',
  'admin.tabs.tips': 'Mẹo trong Ngày',
  'admin.tabs.coupons': 'Mã Giảm giá',
  'admin.tabs.website': 'Trình chỉnh sửa Trang web',
  'admin.tabs.ai': 'Cài đặt AI',
  'admin.tabs.transactions': 'Nhật ký Giao dịch',
  'admin.tabs.stats': 'Thống kê',
  'admin.users.searchPlaceholder': 'Tìm kiếm người dùng (email hoặc tên)...',
  'admin.users.manageSubscription': 'Quản lý đăng ký',
  'admin.users.grantFree': 'Cấp tài khoản miễn phí',
  'admin.users.blockUser': 'Chặn người dùng',
  'admin.users.cancellationPlaceholder': 'Tại sao đăng ký bị hủy?',
  'admin.users.selectPlan': 'Chọn gói',
  'admin.users.subChanged': 'Đăng ký của {{name}} đã được đổi sang {{plan}}',
  'admin.users.noReasonGiven': 'Không đưa ra lý do',
  'admin.users.subCancelled': 'Đăng ký của {{name}} đã bị hủy (có hiệu lực đến {{date}})',
  'admin.users.paused': 'Tạm dừng',
  'admin.users.subPaused': 'Đăng ký của {{name}} đã được tạm dừng',
  'admin.users.subReactivated': 'Đăng ký của {{name}} đã được kích hoạt lại',
  'admin.users.freeAccount': 'Tài khoản Miễn phí',
  'admin.users.blocked': 'Đã chặn',
  'admin.users.cancelledExpiring': 'Đã hủy (sắp hết hạn)',
  'admin.users.cancelledOn': 'Đã hủy:',
  'admin.users.endsOn': 'Kết thúc:',
  'admin.users.daysRemaining': 'ngày còn lại',
  'admin.users.expired': '(Hết hạn)',
  'admin.users.total': 'Tổng:',
  'admin.users.usersLabel': 'người dùng',
  'admin.users.free': 'miễn phí',
  'admin.users.block': 'Chặn',
  'admin.users.unblock': 'Bỏ chặn',
  'admin.users.unblockUser': 'Bỏ chặn người dùng',
  'admin.users.selectAction': 'Chọn hành động',
  'admin.users.cancelSub': 'Hủy đăng ký',
  'admin.users.cancelSubDesc': 'Hủy vào cuối tháng',
  'admin.users.pauseSub': 'Tạm dừng đăng ký',
  'admin.users.pauseSubDesc': 'Tạm dừng tạm thời',
  'admin.users.changePlan': 'Đổi gói',
  'admin.users.changePlanDesc': 'Chuyển sang gói khác',
  'admin.users.reactivateSub': 'Kích hoạt lại đăng ký',
  'admin.users.reactivateDesc': 'Hoàn tác hủy',
  'admin.users.alreadyCancelled': 'Đăng ký đã bị hủy',
  'admin.users.planLabel': 'Gói',
  'admin.users.cancellationReasonOpt': 'Lý do hủy (tùy chọn)',
  'admin.users.cancelInfo1': 'Đăng ký sẽ kết thúc vào',
  'admin.users.cancelInfo2': '(cuối tháng). Cho đến lúc đó người dùng có toàn quyền truy cập. Không hoàn tiền.',
  'admin.users.newPlan': 'Gói mới',
  'admin.users.warning': 'Cảnh báo',
  'admin.users.blockDesc': 'Người dùng sẽ bị đăng xuất ngay lập tức và không thể đăng nhập lại. Tất cả các phiên hoạt động sẽ bị chấm dứt.',
  'admin.users.confirmUnblock': 'Xác nhận bỏ chặn',
  'admin.users.unblockDesc': 'Người dùng có thể đăng nhập lại và sử dụng tất cả các tính năng.',
  'admin.users.afterBlock': 'Sau khi chặn:',
  'admin.users.afterUnblock': 'Sau khi bỏ chặn:',
  'admin.users.noAccountAccess': 'Không có quyền truy cập tài khoản',
  'admin.users.noNewAnalyses': 'Không thể phân tích mới',
  'admin.users.creditsStored': 'Tín dụng và lịch sử vẫn được lưu trữ',
  'admin.users.accessRestored': 'Quyền truy cập tài khoản được khôi phục',
  'admin.users.allFeaturesAvail': 'Tất cả các tính năng lại khả dụng',
  'admin.users.creditsPreserved': 'Tín dụng và lịch sử được bảo toàn',
  'admin.users.downgrade': 'Hạ cấp Gói',
  'admin.users.grantFreeBtn': 'Cấp miễn phí',
  'admin.users.durationMonths': 'Thời hạn (tháng)',
  'admin.users.months': 'tháng',
  'admin.users.freePlan': 'miễn phí',
  'admin.users.freeSummary': 'nhận được',
  'admin.users.withCredits': 'với',
  'admin.users.credits': 'Tín dụng',
  'admin.users.subInfo': 'Thông tin Đăng ký',
  'admin.users.currentPlan': 'Gói Hiện tại',
  'admin.users.joined': 'Tham gia',
  'admin.users.totalSpent': 'Tổng đã chi',
  'admin.users.paymentMethod': 'Phương thức Thanh toán',
  'admin.users.validThrough': 'Hiệu lực đến',
  'admin.users.billingAddress': 'Địa chỉ Thanh toán',
  'admin.users.transactionHistory': 'Lịch sử Giao dịch',
  'admin.users.cancellationDate': 'Ngày hủy',
  'admin.users.validUntil': 'Có hiệu lực đến (cuối tháng)',
  'admin.users.cancellationReason': 'Lý do hủy',
  'admin.users.noReason': 'Không đưa ra lý do',
  'admin.users.timeRemaining': 'Thời gian còn lại',
  'admin.users.daysUntilDeactivation': 'ngày cho đến khi hủy kích hoạt',
  'admin.table.user': 'Người dùng',
  'admin.table.plan': 'Gói',
  'admin.table.subStatus': 'Trạng thái Đăng ký',
  'admin.table.cancellation': 'Hủy',
  'admin.table.payment': 'Phương thức Thanh toán',
  'admin.table.spending': 'Chi tiêu',
  'admin.table.actions': 'Hành động',
  'admin.actions.viewDetails': 'Xem chi tiết',
  'admin.actions.manageSubscription': 'Quản lý đăng ký',
  'admin.actions.grantFree': 'Cấp quyền truy cập miễn phí',
  'admin.actions.block': 'Chặn người dùng',
  'admin.actions.unblock': 'Bỏ chặn người dùng',
  'admin.actions.cancel': 'Hủy',
  'admin.actions.save': 'Lưu',
  'admin.actions.delete': 'Xóa',
  'admin.actions.confirm': 'Xác nhận',
  'admin.actions.done': 'Hoàn tất',
  'admin.actions.edit': 'Sửa',
  'admin.actions.close': 'Đóng',
  'admin.table.status': 'Trạng thái',
  'admin.filter.all': 'Tất cả',
  'admin.subscription.active': 'Hoạt động',
  'admin.subscription.cancelled': 'Đã hủy',
  'admin.subscription.paused': 'Tạm dừng',
  'admin.subscription.unknown': 'Không xác định',
  'admin.status.active': 'Hoạt động',
  'admin.status.inactive': 'Không hoạt động',
  'admin.status.pending': 'Đang chờ',
  'admin.status.approved': 'Đã phê duyệt',
  'admin.status.rejected': 'Đã từ chối',
  'admin.coupons.title': 'Quản lý Mã Giảm giá',
  'admin.coupons.subtitle': 'Tạo và quản lý mã giảm giá',
  'admin.coupons.newCoupon': 'Mã Giảm giá Mới',
  'admin.coupons.registrationCoupons': 'Mã Giảm giá Đăng ký',
  'admin.coupons.trialCoupons': 'Mã Giảm giá Dùng thử',
  'admin.coupons.type': 'Loại',
  'admin.coupons.plan': 'Gói',
  'admin.coupons.value': 'Giá trị',
  'admin.coupons.usage': 'Sử dụng',
  'admin.coupons.validUntil': 'Có hiệu lực đến',
  'admin.coupons.created': 'Đã tạo',
  'admin.coupons.actions': 'Hành động',
  'admin.coupons.copyCode': 'Sao chép mã',
  'admin.coupons.allPlans': 'Tất cả Gói',
  'admin.coupons.discount': 'Giảm giá',
  'admin.coupons.days': 'ngày',
  'admin.coupons.months': 'tháng',
  'admin.coupons.free': 'miễn phí',
  'admin.coupons.unlimited': 'Không giới hạn',
  'admin.coupons.createRegistration': 'Tạo Mã Giảm giá Đăng ký',
  'admin.coupons.createTrial': 'Tạo Mã Giảm giá Dùng thử',
  'admin.coupons.couponCode': 'Mã Giảm giá',
  'admin.coupons.codePlaceholder': 'ví dụ: NF-7X3K9M',
  'admin.coupons.generateCode': 'Tạo mã mới',
  'admin.coupons.alertFillRequired': 'Vui lòng điền vào tất cả các trường bắt buộc',
  'admin.coupons.alertSelectExpiry': 'Vui lòng chọn ngày hết hạn hoặc bật "Hiệu lực không giới hạn"',
  'admin.coupons.alertCreateError': 'Lỗi tạo mã giảm giá',
  'admin.coupons.confirmDelete': 'Bạn có chắc chắn muốn xóa mã giảm giá này không?',
  'admin.coupons.discountPercent': 'Giảm giá (%)',
  'admin.coupons.bonusCredits': 'Tín dụng Thưởng',
  'admin.coupons.freeDuration': 'Thời gian Miễn phí',
  'admin.coupons.maxUses': 'Số lần Sử dụng Tối đa',
  'admin.coupons.expiryDate': 'Ngày Hết hạn',
  'admin.coupons.unlimitedValidity': 'Hiệu lực không giới hạn',
  'admin.coupons.unlimitedUses': 'Sử dụng không giới hạn',
  'admin.coupons.trialCredits': 'Tín dụng Dùng thử',
  'admin.coupons.trialDuration': 'Thời gian Dùng thử',
  'admin.coupons.typePlaceholder': 'ví dụ: Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Thời hạn',
  'admin.stats.totalUsers': 'Tổng Người dùng',
  'admin.stats.monthlyRevenue': 'Doanh thu Hàng tháng',
  'admin.stats.activeSubscriptions': 'Đăng ký Hoạt động',
  'admin.stats.average': 'Trung bình',
  'admin.stats.revenuePerUser': 'Doanh thu trên mỗi Người dùng',
  'admin.stats.grossRevenue': 'Tổng Doanh thu',
  'admin.stats.net': 'THUẦN',
  'admin.stats.netRevenue': 'Doanh thu Thuần',
  'admin.stats.churnRate': 'Tỷ lệ Rời bỏ',
  'admin.stats.planDistribution': 'Phân phối Gói',
  'admin.stats.users': 'người dùng',
  'admin.stats.revenueByPlan': 'Doanh thu theo Gói',
  'admin.stats.recentActivity': 'Hoạt động Gần đây',
  'admin.stats.activity1': 'Thomas Weber đã nâng cấp lên Builder',
  'admin.stats.activity2': 'Người dùng mới đã đăng ký',
  'admin.stats.activity3': 'Anna Schmidt đã nâng cấp lên Pro',
  'admin.stats.hoursAgo2': '2 giờ trước',
  'admin.stats.hoursAgo5': '5 giờ trước',
  'admin.stats.dayAgo1': '1 ngày trước',
  'admin.stats.couponStats': 'Thống kê Mã Giảm giá',
  'admin.stats.totalRedemptions': 'Tổng số Lần Đổi',
  'admin.stats.activeCoupons': 'Mã Giảm giá Hoạt động',
  'admin.stats.registrationRedemptions': 'Lần Đổi Đăng ký',
  'admin.stats.trialRedemptions': 'Lần Đổi Dùng thử',
  'admin.stats.couponDistribution': 'Phân phối Mã Giảm giá',
  'admin.stats.registrationCoupons': 'Mã Giảm giá Đăng ký',
  'admin.stats.trialCoupons': 'Mã Giảm giá Dùng thử',
  'admin.stats.expiredInactive': 'Hết hạn/Không hoạt động',
  'admin.stats.topCoupons': 'Mã Giảm giá Hàng đầu theo Lần Đổi',
  'admin.stats.redemptions': 'lần đổi',
  'admin.stats.noCouponsRedeemed': 'Chưa có mã giảm giá nào được đổi',
  'admin.downgrade.pending': 'đang chờ',
  'admin.downgrade.refunds': 'Hoàn tiền',
  'admin.downgrade.sectionRequests': 'Yêu cầu',
  'admin.downgrade.sectionStats': 'Thống kê',
  'admin.downgrade.sectionRules': 'Quy tắc',
  'admin.downgrade.pendingRequests': 'Yêu cầu Đang chờ',
  'admin.downgrade.approvedRequests': 'Yêu cầu Đã phê duyệt',
  'admin.downgrade.rejectedRequests': 'Yêu cầu Đã từ chối',
  'admin.downgrade.activeRules': 'Quy tắc Hoạt động',
  'admin.downgrade.autoRules': 'Quy tắc Hạ cấp Tự động',
  'admin.downgrade.autoRulesDesc': 'Tạo quy tắc tự động kích hoạt hạ cấp dựa trên hành vi sử dụng',
  'admin.downgrade.newRule': 'Quy tắc Mới',
  'admin.downgrade.totalRules': 'Tổng số Quy tắc',
  'admin.downgrade.triggeredActions': 'Hành động Đã kích hoạt',
  'admin.downgrade.conditionsAnd': 'Điều kiện (liên kết AND)',
  'admin.downgrade.action': 'Hành động',
  'admin.downgrade.successTitle': 'Hạ cấp thành công!',
  'admin.downgrade.successDesc': 'Người dùng đã được hạ cấp thành công và việc hoàn tiền đã được xử lý.',
  'admin.downgrade.closing': 'Đang đóng...',
  'admin.downgrade.title': 'Hạ cấp Người dùng',
  'admin.downgrade.currentPlan': 'Gói Hiện tại',
  'admin.downgrade.spending': 'Chi tiêu',
  'admin.downgrade.availablePlans': 'Các Gói Có sẵn để Hạ cấp',
  'admin.downgrade.perMonth': 'mỗi tháng',
  'admin.downgrade.refundCalc': 'Tính toán Hoàn tiền',
  'admin.downgrade.currentPlanLabel': 'Gói Hiện tại',
  'admin.downgrade.newPlan': 'Gói Mới',
  'admin.downgrade.remainingDays': 'Số Ngày Còn lại',
  'admin.downgrade.daysOf': '15 của 30 ngày',
  'admin.downgrade.proRataRefund': 'Hoàn tiền Theo tỷ lệ',
  'admin.downgrade.importantNote': 'Lưu ý Quan trọng',
  'admin.downgrade.warningDesc': 'Việc hạ cấp sẽ được thực hiện ngay lập tức. Người dùng sẽ mất quyền truy cập vào các tính năng cao cấp và tín dụng vượt quá sẽ bị xóa.',
  'admin.downgrade.processing': 'Đang xử lý...',
  'admin.downgrade.execute': 'Thực hiện Hạ cấp',
  'admin.downgrade.notification': 'Thông báo',
  'admin.downgrade.noNotification': 'Không Thông báo',
  'admin.downgrade.daysPeriod': 'ngày gia hạn',
  'admin.downgrade.created': 'Đã tạo:',
  'admin.downgrade.triggered': 'đã kích hoạt',
  'admin.downgrade.noRules': 'Chưa có quy tắc nào được tạo',
  'admin.downgrade.createFirstRule': 'Tạo quy tắc đầu tiên',
  'admin.downgrade.editRule': 'Sửa Quy tắc',
  'admin.downgrade.createRule': 'Tạo Quy tắc Mới',
  'admin.downgrade.ruleName': 'Tên quy tắc',
  'admin.downgrade.description': 'Mô tả',
  'admin.downgrade.allConditions': 'Điều kiện (tất cả phải được đáp ứng)',
  'admin.downgrade.addCondition': 'Thêm điều kiện',
  'admin.downgrade.type': 'Loại',
  'admin.downgrade.value': 'Giá trị',
  'admin.downgrade.fromPlan': 'Từ gói',
  'admin.downgrade.toPlan': 'Đến gói',
  'admin.condition.inactivity': 'Không hoạt động',
  'admin.condition.creditUsage': 'Sử dụng Tín dụng',
  'admin.condition.loginFrequency': 'Tần suất Đăng nhập',
  'admin.condition.featureUsage': 'Sử dụng Tính năng',
  'admin.condition.supportTickets': 'Yêu cầu Hỗ trợ',
  'admin.operator.lessThan': 'ít hơn',
  'admin.operator.greaterThan': 'nhiều hơn',
  'admin.operator.equals': 'chính xác',
  'admin.operator.between': 'giữa',
  'admin.unit.days': 'ngày',
  'admin.unit.perMonth': 'mỗi tháng',
  'admin.unit.count': 'số lượng',
  'admin.transactions.all': 'Tất cả Giao dịch',
  'admin.transactions.allCards': 'Tất cả Thẻ',
  'admin.transactions.notFound': 'Không tìm thấy giao dịch nào',
  'admin.transactions.totalLabel': 'Tổng',
  'admin.transactions.transactions': 'giao dịch',
  'admin.tips.title': 'Mẹo trong Ngày',
  'admin.tips.subtitle': 'Tạo và quản lý các mẹo hiển thị cho tất cả người dùng',
  'admin.tips.active': 'Hoạt động',
  'admin.tips.currentlyShown': 'Mẹo này hiện đang được hiển thị cho tất cả người dùng',
  'admin.tips.createNew': 'Tạo Mẹo Mới',
  'admin.tips.generating': 'Đang tạo...',
  'admin.tips.generateAI': 'Tạo Mẹo AI',
  'admin.tips.titleLabel': 'Tiêu đề',
  'admin.tips.titlePlaceholder': 'ví dụ: Mẹo trong Ngày',
  'admin.tips.category': 'Danh mục',
  'admin.tips.categoryTip': 'Mẹo',
  'admin.tips.categoryFeature': 'Tính năng Mới',
  'admin.tips.categoryProductivity': 'Năng suất',
  'admin.tips.categoryUpdate': 'Cập nhật',
  'admin.tips.content': 'Nội dung',
  'admin.tips.contentPlaceholder': 'Viết mẹo của bạn cho người dùng tại đây...',
  'admin.tips.addTip': 'Thêm Mẹo',
  'admin.tips.allTips': 'Tất cả Mẹo',
  'admin.tips.noTips': 'Chưa có mẹo nào được tạo',
  'admin.tips.noTipsHint': 'Nhấp vào "Tạo Mẹo AI" để bắt đầu',
  'admin.noData': 'Không có dữ liệu',
  'admin.range.7d': '7 ngày',
  'admin.range.30d': '30 ngày',
  'admin.range.90d': '90 ngày',
  'admin.range.1y': '1 năm',
  'admin.actions.saveSettings': 'Lưu cài đặt',
  'admin.actions.create': 'Tạo',
  'admin.downgrade.sectionReports': 'Báo cáo',
  'admin.downgrade.settings': 'Cài đặt Hạ cấp',
  'admin.downgrade.autoApprove': 'Phê duyệt Tự động',
  'admin.downgrade.autoApproveDesc': 'Tự động phê duyệt yêu cầu hạ cấp',
  'admin.downgrade.refundPolicy': 'Chính sách Hoàn tiền',
  'admin.downgrade.prorata': 'Hoàn tiền theo tỷ lệ',
  'admin.downgrade.prorataDesc': 'Hoàn tiền theo tỷ lệ dựa trên số ngày còn lại',
  'admin.downgrade.fullRefund': 'Hoàn tiền toàn bộ',
  'admin.downgrade.fullRefundDesc': 'Hoàn tiền toàn bộ chênh lệch giá',
  'admin.downgrade.noRefund': 'Không hoàn tiền',
  'admin.downgrade.noRefundDesc': 'Hạ cấp mà không hoàn tiền',
  'admin.downgrade.daysRemaining15': '(với 15 ngày còn lại)',
  'admin.downgrade.requestsTitle': 'Yêu cầu Hạ cấp',
  'admin.downgrade.approvalRate': 'Tỷ lệ phê duyệt',
  'admin.downgrade.mostCommonTransition': 'Chuyển đổi phổ biến nhất',
  'admin.downgrade.mostCommonReason': 'Lý do phổ biến nhất',
  'admin.downgrade.avgProcessingTime': 'Thời gian xử lý TB',
  'admin.downgrade.avgTimeDesc': 'Thời gian trung bình để đưa ra quyết định',
  'admin.downgrade.totalRefunds': 'Tổng Hoàn tiền',
  'admin.downgrade.pendingRefunds': 'Hoàn tiền Đang chờ',
  'admin.downgrade.summary': 'Tóm tắt',
  'admin.downgrade.total': 'Tổng',
  'admin.downgrade.csvDesc': 'Dành cho Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Tải xuống dưới dạng CSV',
  'admin.downgrade.jsonDesc': 'Dành cho nhà phát triển, API',
  'admin.downgrade.downloadJSON': 'Tải xuống dưới dạng JSON',
  'admin.downgrade.exportInfo': 'Bản xuất chứa',
  'admin.downgrade.entries': 'mục từ khoảng thời gian đã chọn',
  'admin.downgrade.topReasons': 'Lý do hạ cấp phổ biến nhất',
  'admin.downgrade.refundHistory': 'Lịch sử Hoàn tiền',
  'admin.downgrade.noRefunds': 'Chưa có hoàn tiền nào',
  'admin.downgrade.statistics': 'Thống kê Hạ cấp',
  'admin.downgrade.requests': 'Yêu cầu',
  'admin.downgrade.monthlyTrend': 'Xu hướng Hàng tháng',
  'admin.downgrade.planTransitions': 'Chuyển đổi Gói',
  'admin.downgrade.trend': 'Xu hướng (so với tháng trước)',
  'admin.downgrade.trendDesc': 'Ít hạ cấp hơn = tốt hơn',
  'admin.coupons.allPlansUniversal': 'Tất cả Gói (Phổ quát)',
  'admin.coupons.onlyStarter': 'Chỉ Starter',
  'admin.coupons.onlyPro': 'Chỉ Pro',
  'admin.coupons.onlyBuilder': 'Chỉ Builder',
  'admin.coupons.allPlansHint': 'Chọn "Tất cả Gói" cho mã giảm giá phổ quát',
  'admin.coupons.discountOptional': 'Giảm giá % (tùy chọn)',
  'admin.coupons.discountPlaceholder': 'ví dụ: 50 cho giảm giá 50%',
  'admin.coupons.bonusCreditsOptional': 'Tín dụng Thưởng (tùy chọn)',
  'admin.coupons.bonusCreditsPlaceholder': 'ví dụ: 500',
  'admin.coupons.freeDurationOptional': 'Thời gian Miễn phí (tùy chọn)',
  'admin.coupons.durationPlaceholder': 'ví dụ: 30',
  'admin.coupons.freeDurationHint': 'ví dụ: 30 ngày sử dụng miễn phí',
  'admin.coupons.noLimit': 'Không giới hạn sử dụng',
  'admin.coupons.noExpiry': 'Không có ngày hết hạn',
  'admin.coupons.creditsPlaceholder': 'ví dụ: 100',
  'admin.coupons.creditsHint': 'Số lượng tín dụng cho quyền truy cập dùng thử',
  'admin.coupons.trialDurationHint': 'Thời gian quyền truy cập dùng thử có hiệu lực',
  'admin.coupons.autoCalculated': 'Tự động tính toán từ thời gian dùng thử',
  'admin.websiteEditor.title': 'Trình chỉnh sửa Trang web',
  'admin.websiteEditor.subtitle': 'Chỉnh sửa tất cả các phần của trang chủ',
  'admin.websiteEditor.openPreview': 'Mở Xem trước',
  'admin.websiteEditor.group.structure': 'Cấu trúc Trang',
  'admin.websiteEditor.group.design': 'Thiết kế & Bố cục',
  'admin.websiteEditor.group.settings': 'Cài đặt',
  'admin.websiteEditor.tab.navbar': 'Điều hướng',
  'admin.websiteEditor.tab.howitworks': 'Cách hoạt động',
  'admin.websiteEditor.tab.about': 'Về chúng tôi',
  'admin.websiteEditor.tab.pricing': 'Bảng giá',
  'admin.websiteEditor.tab.sections': 'Phần',
  'admin.websiteEditor.tab.media': 'Đa phương tiện',
  'admin.websiteEditor.tab.chatwidget': 'Trò chuyện với chúng tôi',
  'admin.websiteEditor.tab.invoice': 'Hóa đơn',
  'admin.websiteEditor.tab.legal': 'Pháp lý',
  'admin.websiteEditor.tab.seo': 'SEO Cơ bản',
  'admin.websiteEditor.tab.advancedseo': 'SEO Nâng cao',
  'admin.websiteEditor.tab.versions': 'Phiên bản',
  'admin.hero.title': 'Chỉnh sửa Phần Anh hùng',
  'admin.hero.subtitle': 'Văn bản, nút và thống kê của trang chủ',
  'admin.hero.reset': 'Đặt lại',
  'admin.hero.save': 'Lưu',
  'admin.hero.savedMsg': 'Đã lưu dữ liệu Anh hùng!',
  'admin.hero.badge': 'Văn bản Huy hiệu',
  'admin.hero.headings': 'Tiêu đề',
  'admin.hero.line1White': 'Dòng 1 (trắng)',
  'admin.hero.line2Gold': 'Dòng 2 (vàng)',
  'admin.hero.subtitleSection': 'Phụ đề',
  'admin.hero.line1': 'Dòng 1',
  'admin.hero.line2': 'Dòng 2',
  'admin.hero.buttons': 'Nút',
  'admin.hero.primaryBtn': 'Nút Chính (vàng)',
  'admin.hero.secondaryBtn': 'Nút Phụ (viền)',
  'admin.hero.stats': 'Thống kê',
  'admin.hero.statN': 'Thống kê {{n}}',
  'admin.hero.value': 'Giá trị',
  'admin.hero.label': 'Nhãn',
  'admin.hero.previewNote': 'Các thay đổi sẽ hiển thị trên trang chủ sau khi lưu. Tải lại trang để xem trước.',

  // Idea History
  'history.title': 'Lịch sử Ý tưởng',
  'history.countLabel': '{{count}} phân tích',
  'history.recentLabel': 'Các phân tích gần đây của bạn',
  'history.exportAll': 'Xuất tất cả',
  'history.metrics.marketSize': 'Quy mô Thị trường',
  'history.metrics.competition': 'Cạnh tranh',
  'history.metrics.startingCapital': 'Vốn Khởi nghiệp',
  'history.metrics.timeToMarket': 'Thời gian Ra mắt',
  'history.metrics.profitPotential': 'Tiềm năng Lợi nhuận',
  'history.metrics.scalability': 'Khả năng Mở rộng',
  'history.summary.title': 'Tóm tắt',
  'history.download': 'Tải xuống',
  'history.downloadJSON': 'Lưu dưới dạng JSON',
  'history.downloadTXT': 'Lưu dưới dạng TXT',
  'history.downloadPDF': 'Lưu dưới dạng PDF',
  'history.fullAnalysis': 'Phân tích Đầy đủ',
  'history.searchPlaceholder': 'Tìm kiếm theo tiêu đề hoặc thẻ...',
  'history.filterAll': 'Tất cả đánh giá',
  'history.loading': 'Đang tải phân tích...',
  'history.noResults': 'Không tìm thấy kết quả',
  'history.empty': 'Chưa có phân tích nào',
  'history.emptyHint': 'Bắt đầu phân tích trong Trợ lý AI',
  'history.delete': 'Xóa',
  'history.cancel': 'Hủy',
  'history.deleteModalTitle': 'Xóa phân tích?',
  'history.deleteModalDesc': '"{{title}}" sẽ bị xóa vĩnh viễn.',
  'history.errorLoading': 'Lỗi tải phân tích',
  'history.deleteSuccess': 'Đã xóa phân tích thành công',
  'history.deleteError': 'Lỗi xóa phân tích',
  'history.jsonExported': 'Đã xuất JSON',
  'history.txtExported': 'Đã xuất TXT',
  'history.allExported': 'Đã xuất {{count}} ý tưởng',
  'history.analysisHeader': 'PHÂN TÍCH Ý TƯỞNG',
  'history.titleLabel': 'Tiêu đề',
  'history.ratingLabel': 'Đánh giá',
  'history.dateLabel': 'Ngày',
  'history.creditsLabel': 'Tín dụng',
  'history.analysisSection': 'Phân tích',

  // Overview
  'overview.title': 'Tổng quan',
  'overview.last24h': '24 giờ qua',
  'overview.analysesToday': 'Phân tích hôm nay',
  'overview.totalAnalyses': 'Tổng phân tích',
  'overview.successRate': 'Tỷ lệ thành công',
  'overview.topRatings': 'Đánh giá hàng đầu',
  'overview.recentActivity': 'Hoạt động gần đây',
  'overview.viewAll': 'Xem tất cả',
  'overview.quickAccess': 'Truy cập nhanh',
  'overview.quick.newAnalysis': 'Bắt đầu phân tích mới',
  'overview.quick.newAnalysisDesc': 'Bắt đầu phân tích ngóc ngách mới hỗ trợ AI',
  'overview.quick.myAnalyses': 'Phân tích của tôi',
  'overview.quick.myAnalysesDesc': 'Xem tất cả phân tích trước đây',
  'overview.quick.buyCredits': 'Mua tín dụng',
  'overview.quick.buyCreditsDesc': 'Thêm tín dụng cho nhiều phân tích hơn',
  'overview.quick.settings': 'Cài đặt',
  'overview.quick.settingsDesc': 'Tùy chỉnh hồ sơ và tùy chọn',
  'overview.unlimitedCredits': 'Tín dụng không giới hạn khả dụng',
  'overview.creditsAvailable': 'tín dụng khả dụng',
  'overview.upgradePlan': 'Nâng cấp gói',
  'overview.buyCredits': 'Mua tín dụng',
  'overview.creditUsage': 'Sử dụng tín dụng tháng này',
  'overview.available': 'khả dụng',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Nâng cấp',
  'admin.transactions.downgrades': 'Hạ cấp',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} hiện có {{months}} tháng gói {{plan}} miễn phí',
  'admin.users.blockSuccess': '{{name}} đã bị chặn',
  'admin.users.unblockSuccess': '{{name}} đã được bỏ chặn',
  'admin.users.removeFreeSuccess': 'Trạng thái miễn phí của {{name}} đã được xóa',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Miễn phí',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Khám phá Tính năng Mới',
  'admin.tips.productivityBoost': 'Tăng Năng suất',
  'admin.tips.importantUpdate': 'Cập nhật Quan trọng',
  'admin.tips.tipOfDay': 'Mẹo trong Ngày',

  'admin.actions.activate': 'Kích hoạt',
  'admin.actions.deactivate': 'Hủy kích hoạt',
  'admin.websiteEditor.tab.features': 'Tính năng',
  'admin.websiteEditor.tab.testimonials': 'Lời chứng thực',
  'admin.websiteEditor.tab.faq': 'Câu hỏi thường gặp',
  'admin.websiteEditor.tab.cta': 'Kêu gọi Hành động',
  'admin.websiteEditor.tab.footer': 'Chân trang',
  'admin.websiteEditor.tab.design': 'Thiết kế',
  'admin.websiteEditor.tab.customcode': 'Mã Tùy chỉnh',
  'admin.websiteEditor.tab.socials': 'Truyền thông Xã hội',
  'admin.websiteEditor.tab.importexport': 'Nhập/Xuất',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Cài đặt Trợ lý AI',
  'admin.ai.subtitle': 'Định cấu hình hành vi, phong cách và độ sâu phân tích',
  'admin.ai.smartWeightingActive': 'Tính năng Trọng số Thông minh Hoạt động',
  'admin.ai.smartWeightingDesc': 'AI tự động kết hợp tất cả các góc nhìn với trọng số thông minh. Với nhiều cài đặt sẵn, cái đầu tiên được tính trọng số cao hơn (cài đặt sẵn chính). Bạn cũng có thể điều chỉnh trọng số thủ công.',
  'admin.ai.modelTitle': 'Mô hình AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'Chọn công cụ AI cho tất cả phân tích của người dùng',
  'admin.ai.activeModel': 'Mô hình hoạt động:',
  'admin.ai.activeModelDesc': 'Tất cả người dùng nhận phản hồi từ mô hình này.',
  'admin.ai.recommendations': 'Đề xuất cho Kết quả Tối ưu',
  'admin.ai.new': 'MỚI',
  'admin.ai.recommendationsDesc': 'Tổ hợp cài đặt sẵn đã được kiểm nghiệm cho chất lượng phân tích tốt nhất',
  'admin.ai.recommendationsInfo': 'Các tổ hợp này đã được thử nghiệm và mang lại kết quả tốt nhất. Nhấp vào một đề xuất để áp dụng trực tiếp.',
  'admin.ai.active': 'HOẠT ĐỘNG',
  'admin.ai.apply': 'Áp dụng',
  'admin.ai.avoid': 'Tránh',
  'admin.ai.excellentQuality': 'Chất lượng Xuất sắc',
  'admin.ai.goodQuality': 'Chất lượng Tốt',
  'admin.ai.poorQuality': 'Chất lượng Pha loãng - Không được Khuyến nghị',
  'admin.ai.proTips': 'Mẹo Chuyên nghiệp',
  'admin.ai.tip1Title': '2 cài đặt sẵn là tối ưu:',
  'admin.ai.tip1Desc': 'Góc nhìn rõ ràng không bị pha loãng',
  'admin.ai.tip2Title': 'Cài đặt sẵn chính rất quan trọng:',
  'admin.ai.tip2Desc': 'Cài đặt sẵn đầu tiên có ảnh hưởng lớn nhất',
  'admin.ai.tip3Title': 'Tránh đối lập:',
  'admin.ai.tip3Desc': '"CỰC ĐOAN" + "Sáng tạo" = mâu thuẫn',
  'admin.ai.tip4Title': 'Tối đa 3 cài đặt sẵn:',
  'admin.ai.tip4Desc': 'Với 4+ cài đặt sẵn, kết quả trở nên quá chung chung',
  'admin.ai.warningManyPresets': 'Cảnh báo: Nhiều Cài đặt sẵn',
  'admin.ai.warningManyPresetsDesc': 'Bạn đã chọn {{count}} cài đặt sẵn. Điều này có thể làm loãng kết quả.',
  'admin.ai.warningRecommend': 'Khuyến nghị: Tối đa 2-3 cài đặt sẵn',
  'admin.ai.forOptimalResults': 'để có kết quả tối ưu.',
  'admin.ai.presets': 'Cài đặt sẵn',
  'admin.ai.multiSelect': '(có thể chọn nhiều)',
  'admin.ai.presetsDesc': 'Chọn một hoặc nhiều cài đặt sẵn. Cài đặt sẵn đầu tiên là cài đặt sẵn chính với trọng số cao nhất.',
  'admin.ai.primaryPreset': 'Cài đặt sẵn Chính',
  'admin.ai.weightControl': 'Kiểm soát Trọng số',
  'admin.ai.weightControlDesc': 'Điều chỉnh mức độ ảnh hưởng của mỗi cài đặt sẵn đến phân tích',
  'admin.ai.manual': 'Thủ công',
  'admin.ai.automatic': 'Tự động',
  'admin.ai.autoWeightingActive': 'Tính năng trọng số tự động hoạt động:',
  'admin.ai.autoWeightingDesc': 'Trọng số được tự động tối ưu hóa dựa trên số lượng cài đặt sẵn.',
  'admin.ai.primary': 'CHÍNH',
  'admin.ai.totalWeight': 'Tổng',
  'admin.ai.shouldBe100': 'nên là 100%',
  'admin.ai.normalize': 'Chuẩn hóa',
  'admin.ai.combinedSettings': 'Cài đặt Kết hợp',
  'admin.ai.presetsCount': 'cài đặt sẵn',
  'admin.ai.strictness': 'Mức độ Nghiêm khắc',
  'admin.ai.realism': 'Chủ nghĩa Hiện thực',
  'admin.ai.creativity': 'Sáng tạo',
  'admin.ai.detailLevel': 'Mức độ Chi tiết',
  'admin.ai.customInstructions': 'Hướng dẫn Tùy chỉnh',
  'admin.ai.customInstructionsDesc': 'Các hướng dẫn bổ sung được kết hợp với các cài đặt sẵn',
  'admin.ai.customInstructionsPlaceholder': 'ví dụ: "Tập trung vào thị trường Đức", "Luôn sử dụng số liệu cụ thể", "So sánh với đối thủ hiện có", "Luôn trả lời kèm ví dụ"...',
  'admin.ai.customInstructionsHint': 'Các hướng dẫn này tự động được kết hợp với các cài đặt sẵn đã chọn.',
  'admin.ai.manualFinetuning': 'Tinh chỉnh Thủ công',
  'admin.ai.manualFinetuningHint': '(tùy chọn, ghi đè giá trị cài đặt sẵn)',
  'admin.ai.manualFinetuningDesc': 'Điều chỉnh thủ công các giá trị kết hợp nếu bạn muốn tinh chỉnh điều gì đó.',
  'admin.ai.tone': 'Giọng điệu',
  'admin.ai.mild': 'Nhẹ nhàng',
  'admin.ai.strict': 'Nghiêm khắc',
  'admin.ai.creative': 'Sáng tạo',
  'admin.ai.realistic': 'Thực tế',
  'admin.ai.conservative': 'Bảo thủ',
  'admin.ai.compact': 'Nhỏ gọn',
  'admin.ai.detailed': 'Chi tiết',
  'admin.ai.responseLength': 'Độ dài Phản hồi',
  'admin.ai.short': 'Ngắn & Súc tích',
  'admin.ai.medium': 'Trung bình',
  'admin.ai.long': 'Chi tiết',
  'admin.ai.focusAreas': 'Lĩnh vực Trọng tâm Phân tích',
  'admin.ai.autoRating': 'Đánh giá Tự động',
  'admin.ai.autoRatingDesc': 'Mỗi phân tích tự động nhận được đánh giá (Tốt/Trung bình/Kém)',
  'admin.ai.showSources': 'Hiển thị Nguồn',
  'admin.ai.showSourcesDesc': 'Tham chiếu đến nguồn dữ liệu và dữ liệu thị trường trong phản hồi',
  'admin.ai.hidePreview': 'Ẩn Xem trước',
  'admin.ai.showPreview': 'Hiển thị Xem trước',
  'admin.ai.aiBehavior': 'Hành vi AI',
  'admin.ai.length': 'Độ dài',
  'admin.ai.liveExample': 'Ví dụ Trực tiếp',
  'admin.ai.testSettings': 'Kiểm tra cài đặt của bạn',
  'admin.ai.selectExampleQuestion': 'Chọn câu hỏi ví dụ:',
  'admin.ai.userAsks': 'Người dùng hỏi:',
  'admin.ai.generating': 'AI đang tạo phản hồi...',
  'admin.ai.generateExample': 'Tạo Phản hồi Mẫu',
  'admin.ai.aiResponds': 'Trợ lý AI trả lời:',
  'admin.ai.generateHint': 'Nhấp vào "Tạo Phản hồi Mẫu" để xem AI phản hồi như thế nào với cài đặt của bạn.',
  'admin.ai.reset': 'Đặt lại',
  'admin.ai.saved': 'Đã lưu!',
  'admin.ai.saveSettings': 'Lưu Cài đặt',

  // --- Table headers ---
  'admin.coupons.code': 'Mã',
  'admin.coupons.credits': 'Tín dụng',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Phân tích cân bằng với chất lượng cao. Lựa chọn tốt nhất cho hầu hết các đánh giá ngóc ngách và xác nhận ý tưởng.',
  'admin.ai.model.preciseAnalyses': 'Phân tích Chính xác',
  'admin.ai.model.bestBalance': 'Cân bằng Tốt nhất',
  'admin.ai.model.recommended': 'Khuyến nghị',
  'admin.ai.model.fastDesc': 'Phản hồi nhanh như chớp để kiểm tra ngóc ngách nhanh, động não và đánh giá ban đầu. Lý tưởng khi tốc độ quan trọng.',
  'admin.ai.model.fast': 'NHANH',
  'admin.ai.model.fastestResponses': 'Phản hồi Nhanh nhất',
  'admin.ai.model.thinkingDesc': 'Phân tích sâu với khả năng suy luận logic nâng cao. Dành cho phân tích thị trường phức tạp, đánh giá phê phán và lập kế hoạch chiến lược.',
  'admin.ai.model.deepestAnalysis': 'Phân tích Sâu nhất',
  'admin.ai.model.logicalThinking': 'Suy luận Logic',
  'admin.ai.model.strategy': 'Chiến lược',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Phân tích Nghiêm khắc',
  'admin.ai.preset.strict.desc': 'Phê phán, dựa trên thực tế, không tô vẽ. Phơi bày điểm yếu một cách tàn nhẫn.',
  'admin.ai.preset.extreme.name': 'Phân tích CỰC ĐOAN',
  'admin.ai.preset.extreme.desc': 'Mức độ nghiêm khắc tối đa, chỉ trích tàn nhẫn, tập trung vào kịch bản xấu nhất. Chỉ dành cho kiểm tra thực tế khắc nghiệt.',
  'admin.ai.preset.professional.name': 'Chuyên nghiệp',
  'admin.ai.preset.professional.desc': 'Khách quan, có cấu trúc, cân bằng. Như một nhà tư vấn kinh doanh giàu kinh nghiệm.',
  'admin.ai.preset.realistic.name': 'Thực tế',
  'admin.ai.preset.realistic.desc': 'Trung thực và thực tiễn. Tập trung vào khả năng thực hiện khả thi và dữ liệu thị trường thực tế.',
  'admin.ai.preset.creative.name': 'Sáng tạo & Tạo động lực',
  'admin.ai.preset.creative.desc': 'Truyền cảm hứng, giàu ý tưởng, tích cực. Tìm kiếm cơ hội và con đường độc đáo.',
  'admin.ai.preset.balanced.name': 'Cân bằng',
  'admin.ai.preset.balanced.desc': 'Sự pha trộn tốt giữa phê bình và động lực. Chế độ mặc định.',
  'admin.ai.preset.investor.name': 'Góc nhìn Nhà đầu tư',
  'admin.ai.preset.investor.desc': 'Giống như một Nhà đầu tư Mạo hiểm. Tập trung vào mở rộng quy mô, ROI và chiến lược thoái vốn.',
  'admin.ai.preset.startup-coach.name': 'Huấn luyện viên Khởi nghiệp',
  'admin.ai.preset.startup-coach.desc': 'Người cố vấn thực tế cho người sáng lập. Tập trung vào thực hiện nhanh và MVP.',
  'admin.ai.preset.market-researcher.name': 'Nhà nghiên cứu Thị trường',
  'admin.ai.preset.market-researcher.desc': 'Dựa trên dữ liệu và phân tích. Phân tích thị trường và cạnh tranh chuyên sâu.',
  'admin.ai.preset.risk-analyst.name': 'Chuyên gia Phân tích Rủi ro',
  'admin.ai.preset.risk-analyst.desc': 'Tập trung vào rủi ro và kịch bản xấu nhất. Dành cho lập kế hoạch thực tế.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Phân tích Thị trường',
  'admin.ai.focus.wettbewerb': 'Cạnh tranh',
  'admin.ai.focus.monetarisierung': 'Kiếm tiền',
  'admin.ai.focus.risiken': 'Rủi ro',
  'admin.ai.focus.finanzen': 'Tài chính',
  'admin.ai.focus.skalierung': 'Mở rộng',
  'admin.ai.focus.innovation': 'Đổi mới',
  'admin.ai.focus.trends': 'Xu hướng',
  'admin.ai.focus.differenzierung': 'Sự khác biệt',
  'admin.ai.focus.umsetzung': 'Thực hiện',
  'admin.ai.focus.zielgruppe': 'Đối tượng Mục tiêu',
  'admin.ai.focus.marketing': 'Tiếp thị',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Trực tiếp & Thẳng thắn',
  'admin.ai.tone.professionell': 'Chuyên nghiệp & Khách quan',
  'admin.ai.tone.ehrlich': 'Trung thực & Thực tế',
  'admin.ai.tone.motivierend': 'Tạo động lực & Tích cực',
  'admin.ai.tone.freundlich': 'Thân thiện & Hỗ trợ',
  'admin.ai.tone.akademisch': 'Hàn lâm & Phân tích',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Bạn đề xuất ngóc ngách sinh lợi nào?',
  'admin.ai.question.evaluate': 'Đánh giá ý tưởng của tôi: Một ứng dụng cho người nuôi chó',
  'admin.ai.question.trends': 'Xu hướng nào hiện có tiềm năng?',
  'admin.ai.question.sharpen': 'Làm cách nào tôi có thể mài sắc ngóc ngách của mình?',

  'admin.ai.rec.bestCombination.title': '🏆 Tổ hợp Tốt nhất (2 Cài đặt sẵn)',
  'admin.ai.rec.bestCombination.desc': 'Phê phán nhưng mang tính xây dựng, với các bước hành động cụ thể',
  'admin.ai.rec.bestCombination.useCase': 'Được khuyến nghị cho hầu hết các phân tích',

  'admin.ai.rec.balancedThree.title': '⚖️ Cân bằng (3 Cài đặt sẵn)',
  'admin.ai.rec.balancedThree.desc': 'Chuyên nghiệp, thực tế và thân thiện với nhà đầu tư',
  'admin.ai.rec.balancedThree.useCase': 'Dành cho phân tích kinh doanh toàn diện',

  'admin.ai.rec.creativeDriven.title': '💡 Sáng tạo & Tạo động lực (2 Cài đặt sẵn)',
  'admin.ai.rec.creativeDriven.desc': 'Truyền cảm hứng với các mẹo thực hiện thực tế',
  'admin.ai.rec.creativeDriven.useCase': 'Dành cho việc lên ý tưởng và động não',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Mở menu',
  'header.home': 'Trang chủ',
  'header.notifications': 'Thông báo',
  'header.settings': 'Cài đặt',
  'header.profile': 'Hồ sơ',
  'sidebar.collapse': 'Thu gọn thanh bên',
  'sidebar.expand': 'Mở rộng thanh bên',
  'sidebar.close': 'Đóng menu',
  'sidebar.plan': 'Gói',
  'sidebar.backToWebsite': 'Quay lại trang web',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Chào mừng quay lại',
  'overview.greetingSub': 'Đây là những gì đang xảy ra trên bàn phán quyết của bạn.',
  'overview.heroCta': 'Phán quyết mới',
  'overview.currentPlan': 'Gói hiện tại',
  'overview.creditsLabel': 'tín dụng',
  'overview.usedThisCycle': 'Đã dùng chu kỳ này',
  'overview.resetsOn': 'Đặt lại vào',
  'overview.unlimitedTitle': 'Không giới hạn',
  'overview.builderPerk': 'Bạn có quyền truy cập Builder đầy đủ — không giới hạn.',
  'overview.runOne': 'Chạy phán quyết',
  'overview.lastVerdicts': '5 phán quyết gần nhất của bạn',
  'overview.noActivity': 'Chưa có phán quyết — bắt đầu phân tích đầu tiên',
  'overview.tipTitle': 'Mẹo',
  'overview.tipBody': 'Chạy một ý tưởng qua hai ngôn ngữ — nếu phán quyết nhẹ đi, giả định của bạn mang tính địa phương, không toàn cầu.',
  'onboard.skip': "Bỏ qua",
  'onboard.cta.next': "Tiếp theo",
  'onboard.cta.start': "Bắt đầu",
  'onboard.s1.title': "Chào mừng đến với IdeaVerdict",
  'onboard.s1.body': "Phán quyết AI về ý tưởng kinh doanh của bạn — trước khi bạn bắt tay vào làm.",
  'onboard.s2.title': "Phán quyết thẳng thắn đến tàn nhẫn",
  'onboard.s2.body': "Không tâng bốc, không nịnh nọt. Dữ liệu thị trường thật, đối thủ thật, rủi ro thật.",
  'onboard.s3.title': "Báo cáo Builder dạng PDF",
  'onboard.s3.body': "Tạo báo cáo từ 25–75 trang với đầy đủ kiến trúc, tài chính và chiến lược tiếp cận thị trường.",
  'onboard.s4.title': "Khi bạn đã sẵn sàng",
  'onboard.s4.body': "Đăng ký và nhận phán quyết đầu tiên trong vòng một phút.",
  'builderReport.title': "Building your Builder Report",
  'builderReport.subtitle': "Comprehensive analysis + developer briefing — downloads as PDF when ready.",
  'builderReport.idea': "Your idea",
  'builderReport.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'builderReport.cta': "Generate Report",
  'builderReport.credits': "credits",
  'builderReport.deductedNow': "Deducted on success",
  'builderReport.dontClose': "Please don't close this window — generation can take 30-90 seconds.",
  'builderReport.done': "PDF downloaded — check your downloads folder.",
  'builderReport.failed': "Tạo báo cáo thất bại",
  'builderReport.close': "Close",
  'builderReport.cancel': "Cancel",
  'builderReport.running': "Generating…",
  'builderReport.retry': "Try again",
  'builderReport.unknownError': "Generation failed. Your credits should be refunded.",
  'builderReport.signInRequired': "You must be signed in to generate a report.",
  'builderReport.ideaRequired': "Please describe your idea so the AI has something to analyze.",
  'builderReport.fromChat': "From your current conversation",
  'builderReport.noIdeaDetected': "Using the idea we have been discussing.",
  'builderReport.contextHint': "The AI will use everything from this chat — no new idea will be invented.",
  'builderReport.step.core': "Generating core analysis",
  'builderReport.step.market': "Adding extended market analysis",
  'builderReport.step.tech': "Adding technical architecture",
  'builderReport.step.financials': "Adding financial models",
  'builderReport.step.compet': "Adding competitive intelligence",
  'builderReport.step.gtm': "Adding go-to-market strategy",
  'builderReport.step.deepdive': "Adding industry deep-dive",
  'builderReport.step.pdf': "Compiling the PDF…",
  'briefing.title': "Building your Developer Briefing",
  'briefing.subtitle': "11-section technical briefing — downloads as PDF when ready.",
  'briefing.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'briefing.cta': "Generate Briefing",
  'briefing.step.core': "Generating developer briefing",
  'briefing.step.pdf': "Compiling the PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Nhiều credit hơn + báo cáo 50 trang",
  'pricing.gold.credits': "12,500 Credit mỗi tháng",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Gói cao nhất + báo cáo 75 trang",
  'pricing.platinum.credits': "15,000 Credit mỗi tháng",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "vi" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Only {{count}} Credits left!",
  'trial.upgradeNow': "Nâng cấp ngay →",
  'trial.upgradeNowArrow': "Upgrade now →",
  'trial.creditsExhausted': "Credits exhausted",
  'trial.upgradeForUnlimited': "Upgrade for unlimited use",
  'trial.noCreditsPlaceholder': "No credits left…",
  'hero.badgeHonest': "Thẳng thắn đến tàn nhẫn",
  'hero.badge60sec': "Phán quyết trong 60 giây",
  'hero.badge20Lang': "Hơn 20 ngôn ngữ",
  'hero.widget.label': "Phán quyết ý tưởng",
  'hero.widget.passed': "ĐẠT",
  'hero.widget.demoIdea': "Gia sư AI cho sinh viên y khoa",
  'hero.widget.market': "Thị trường",
  'hero.widget.demand': "Nhu cầu",
  'hero.widget.competition': "Cạnh tranh",
  'hero.widget.verdictReady': "Phán quyết sẵn sàng · 47 giây",
  'hero.widget.riskFlagged': "Đã đánh dấu rủi ro",
  'hero.widget.crowdedMarket': "Crowded market · 4 incumbents",
  'hero.widget.suggestedPivot': "Đề xuất chuyển hướng",
  'hero.widget.nicheBySpecialty': "Niche by specialty",
  'hero.widget.feasibilityGain': "+38% feasibility",
  'hero.widget.analysisDone': "Đã phân tích xong",
  'hero.widget.metrics56': "5 of 6 metrics",
  'hero.stats.verdictSpeed': "Verdict speed",
  'cta.badge': "Phán quyết trong 60 giây",
  'cta.subtitleEnd': "không cần đoán mò.",
  'cta.signinPrompt': "Đã có tài khoản? Đăng nhập",
  'cta.trustTrial': "Dùng thử miễn phí 7 ngày",
  'cta.trustNoCard': "Không cần thẻ",
  'cta.trustCancel': "Hủy bất cứ lúc nào",
  'footer.themeLabel': "Giao diện:",
  'footer.lightMode': "Chế độ sáng",
  'footer.darkMode': "Chế độ tối",
  'footer.sectionProduct': "Sản phẩm",
  'footer.sectionLegal': "Pháp lý",
  'nav.switchLight': "Chuyển sang chế độ sáng",
  'nav.switchDark': "Chuyển sang chế độ tối",
  'features.badge': "Vì sao chọn IdeaVerdict",
  'features.mainFeatureLabel': "Tiêu đề chính",
  'faq.badge': "FAQ",
  'trial.lowCredits': "Chỉ còn {credits} credit!",
  'trial.outOfCredits': "Hết credit",
  'trial.outOfCreditsDesc': "Nâng cấp để tiếp tục nhận phán quyết.",
  'trial.viewPlans': "Xem các gói",
  'trial.tryDemo': "Thử bản demo",
  'hero.widget.crowded': "Thị trường đông đúc · 4 ông lớn",
  'hero.widget.nicheBySpec': "Ngách theo chuyên khoa",
  'hero.widget.feasibilityUp': "+38% tính khả thi",
  'hero.widget.fiveOfSix': "5 trên 6 chỉ số",
  'builderReport.modalTitle': "Báo cáo Builder",
  'builderReport.modalSubtitle': "Tạo PDF toàn diện cho ý tưởng của bạn",
  'builderReport.formatLabel': "Định dạng báo cáo",
  'builderReport.formatStandard': "Báo cáo tiêu chuẩn",
  'builderReport.formatExec': "Tóm tắt điều hành",
  'builderReport.toneLabel': "Giọng văn",
  'builderReport.toneProfessional': "Chuyên nghiệp",
  'builderReport.toneCasual': "Thân mật",
  'builderReport.toneTechnical': "Kỹ thuật",
  'builderReport.sectionsLabel': "Các phần cần đưa vào",
  'builderReport.sectionMarket': "Phân tích thị trường",
  'builderReport.sectionCompetition': "Bối cảnh cạnh tranh",
  'builderReport.sectionFinancial': "Mô hình tài chính",
  'builderReport.sectionArchitecture': "Kiến trúc kỹ thuật",
  'builderReport.sectionGTM': "Kế hoạch tiếp cận thị trường",
  'builderReport.sectionRisks': "Sổ đăng ký rủi ro",
  'builderReport.sectionRoadmap': "Lộ trình sản phẩm",
  'builderReport.sectionTeam': "Kế hoạch nhân sự & tuyển dụng",
  'builderReport.actionGenerate': "Tạo báo cáo",
  'builderReport.actionCancel': "Hủy",
  'builderReport.actionDownload': "Tải PDF",
  'builderReport.statusGenerating': "Đang tạo báo cáo của bạn…",
  'builderReport.statusComplete': "Báo cáo đã sẵn sàng",
  'builderReport.statusError': "Đã xảy ra lỗi. Thử lại.",
  'builderReport.creditsRequired': "Việc này sẽ dùng {credits} credit.",
  'builderReport.pageCount': "{pages} trang",
  'builderReport.tip1': "Mẹo: hãy cụ thể về khách hàng mục tiêu để phân tích sắc bén hơn.",
  'builderReport.tip2': "Mẹo: đưa vào số liệu doanh thu ban đầu nếu bạn có.",
  'builderReport.tip3': "Mẹo: nêu rõ ưu tiên công nghệ nếu có.",
  'builderReport.errorNotEnough': "Bạn không đủ credit cho báo cáo này.",
  'builderReport.errorUpgrade': "Nâng cấp lên gói cao hơn",
  'builderReport.errorTryStandard': "Hãy thử báo cáo Tiêu chuẩn",
  'builderReport.success': "Báo cáo Builder của bạn đã sẵn sàng.",
  'builderReport.previewBadge': "Xem trước",
  'builderReport.previewNote': "Đây là bản xem trước. Tạo PDF đầy đủ để xem tất cả các phần.",
  'builderReport.includesLabel': "Bao gồm",
  'builderReport.pagesIncluded': "{pages} trang phân tích",
  'builderReport.estimatedTime': "Thời gian ước tính: {minutes} phút",
  'builderReport.fullReport': "Báo cáo đầy đủ",
  'builderReport.execSummary': "Tóm tắt điều hành",
  'chatError.planRestriction': "Tính năng này yêu cầu gói cao hơn.",
  'chatError.creditDeduction': "Xử lý thanh toán thất bại. Vui lòng thử lại.",
  'chatError.aiService': "Dịch vụ AI tạm thời không khả dụng. Tín dụng của bạn không bị trừ. Vui lòng thử lại.",
  'chatError.parseError': "Định dạng phản hồi không mong đợi. Vui lòng thử lại.",
  'chatError.sessionExpired': "Phiên của bạn đã hết hạn. Vui lòng đăng nhập lại.",
  'chatError.timeout': "Yêu cầu mất quá nhiều thời gian. Vui lòng thử lại.",
  'chatError.generic': "Không nhận được phản hồi. Vui lòng thử lại.",
  'pricing.builder.report': "Builder Report 25 trang",
  'pricing.gold.report': "Builder Report 50 trang",
  'pricing.platinum.report': "Builder Report 75 trang",
  'auth.bestValue': "Giá trị tốt nhất",
  'auth.elite': "Cao cấp",
  'builderReport.friendlyError': "Lần này chúng tôi không thể hoàn thành báo cáo của bạn. Tín dụng của bạn không bị trừ — vui lòng thử lại sau giây lát.",
  'builderReport.persistHint': "Nếu vấn đề tiếp tục, vui lòng liên hệ support@ideaverdict.ai.",
};
